// source: ea-hosting.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
goog.object.extend(proto, google_protobuf_struct_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.eaconnect.BrokerProfile', null, global);
goog.exportSymbol('proto.eaconnect.CheckBrokerProfileRequest', null, global);
goog.exportSymbol('proto.eaconnect.CheckBrokerProfileResponse', null, global);
goog.exportSymbol('proto.eaconnect.CompileJob', null, global);
goog.exportSymbol('proto.eaconnect.CreateBrokerProfileRequest', null, global);
goog.exportSymbol('proto.eaconnect.CreateInstanceRequest', null, global);
goog.exportSymbol('proto.eaconnect.DeleteBrokerProfileRequest', null, global);
goog.exportSymbol('proto.eaconnect.DeleteInstanceRequest', null, global);
goog.exportSymbol('proto.eaconnect.DismissUploadRequest', null, global);
goog.exportSymbol('proto.eaconnect.DismissUploadResponse', null, global);
goog.exportSymbol('proto.eaconnect.EquitySample', null, global);
goog.exportSymbol('proto.eaconnect.GetBrokerProfileSymbolsRequest', null, global);
goog.exportSymbol('proto.eaconnect.GetBrokerProfileSymbolsResponse', null, global);
goog.exportSymbol('proto.eaconnect.GetCompileJobRequest', null, global);
goog.exportSymbol('proto.eaconnect.GetHostingOverviewRequest', null, global);
goog.exportSymbol('proto.eaconnect.GetInstanceJournalRequest', null, global);
goog.exportSymbol('proto.eaconnect.GetInstanceJournalResponse', null, global);
goog.exportSymbol('proto.eaconnect.GetInstanceMetricsRequest', null, global);
goog.exportSymbol('proto.eaconnect.GetInstanceRequest', null, global);
goog.exportSymbol('proto.eaconnect.GetInstanceStatusRequest', null, global);
goog.exportSymbol('proto.eaconnect.GetSettingsSchemaRequest', null, global);
goog.exportSymbol('proto.eaconnect.GetSettingsSchemaResponse', null, global);
goog.exportSymbol('proto.eaconnect.GetSetupJobRequest', null, global);
goog.exportSymbol('proto.eaconnect.HostingOverview', null, global);
goog.exportSymbol('proto.eaconnect.Instance', null, global);
goog.exportSymbol('proto.eaconnect.InstanceAutoRestartStatus', null, global);
goog.exportSymbol('proto.eaconnect.InstanceEvent', null, global);
goog.exportSymbol('proto.eaconnect.InstanceMetrics', null, global);
goog.exportSymbol('proto.eaconnect.InstanceRestartPolicy', null, global);
goog.exportSymbol('proto.eaconnect.InstanceStatus', null, global);
goog.exportSymbol('proto.eaconnect.JournalLine', null, global);
goog.exportSymbol('proto.eaconnect.LifecycleUpdate', null, global);
goog.exportSymbol('proto.eaconnect.ListBrokerProfilesRequest', null, global);
goog.exportSymbol('proto.eaconnect.ListBrokerProfilesResponse', null, global);
goog.exportSymbol('proto.eaconnect.ListEquityHistoryRequest', null, global);
goog.exportSymbol('proto.eaconnect.ListEquityHistoryResponse', null, global);
goog.exportSymbol('proto.eaconnect.ListInstancesRequest', null, global);
goog.exportSymbol('proto.eaconnect.ListInstancesResponse', null, global);
goog.exportSymbol('proto.eaconnect.ListSettingsVersionsRequest', null, global);
goog.exportSymbol('proto.eaconnect.ListSettingsVersionsResponse', null, global);
goog.exportSymbol('proto.eaconnect.ListUploadsRequest', null, global);
goog.exportSymbol('proto.eaconnect.ListUploadsResponse', null, global);
goog.exportSymbol('proto.eaconnect.LogStreamClose', null, global);
goog.exportSymbol('proto.eaconnect.LogStreamFrame', null, global);
goog.exportSymbol('proto.eaconnect.LogStreamFrame.RecordCase', null, global);
goog.exportSymbol('proto.eaconnect.LogStreamIdentity', null, global);
goog.exportSymbol('proto.eaconnect.LogStreamView', null, global);
goog.exportSymbol('proto.eaconnect.RestartInstanceRequest', null, global);
goog.exportSymbol('proto.eaconnect.RollbackSettingsRequest', null, global);
goog.exportSymbol('proto.eaconnect.SettingsSchemaResult', null, global);
goog.exportSymbol('proto.eaconnect.SettingsVersion', null, global);
goog.exportSymbol('proto.eaconnect.SetupJob', null, global);
goog.exportSymbol('proto.eaconnect.StartCompileJobRequest', null, global);
goog.exportSymbol('proto.eaconnect.StartInstanceRequest', null, global);
goog.exportSymbol('proto.eaconnect.StartSetupJobRequest', null, global);
goog.exportSymbol('proto.eaconnect.StartSetupJobResponse', null, global);
goog.exportSymbol('proto.eaconnect.StopInstanceRequest', null, global);
goog.exportSymbol('proto.eaconnect.StreamInstanceLogsRequest', null, global);
goog.exportSymbol('proto.eaconnect.StreamLifecycleEventsRequest', null, global);
goog.exportSymbol('proto.eaconnect.StreamLogLine', null, global);
goog.exportSymbol('proto.eaconnect.TerminalOptions', null, global);
goog.exportSymbol('proto.eaconnect.UpdateBrokerProfileRequest', null, global);
goog.exportSymbol('proto.eaconnect.UpdateInstanceRestartPolicyRequest', null, global);
goog.exportSymbol('proto.eaconnect.UpdateSettingsRequest', null, global);
goog.exportSymbol('proto.eaconnect.UploadEARequest', null, global);
goog.exportSymbol('proto.eaconnect.UploadEAResponse', null, global);
goog.exportSymbol('proto.eaconnect.UploadEASourceRequest', null, global);
goog.exportSymbol('proto.eaconnect.UploadEntry', null, global);
goog.exportSymbol('proto.eaconnect.UploadSettingsSetRequest', null, global);
goog.exportSymbol('proto.eaconnect.ValidateBrokerLoginRequest', null, global);
goog.exportSymbol('proto.eaconnect.ValidateBrokerLoginResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.UploadEARequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.UploadEARequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.UploadEARequest.displayName = 'proto.eaconnect.UploadEARequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.UploadEAResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.UploadEAResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.UploadEAResponse.displayName = 'proto.eaconnect.UploadEAResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.StartSetupJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.eaconnect.StartSetupJobRequest.repeatedFields_, null);
};
goog.inherits(proto.eaconnect.StartSetupJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.StartSetupJobRequest.displayName = 'proto.eaconnect.StartSetupJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.StartSetupJobResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.StartSetupJobResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.StartSetupJobResponse.displayName = 'proto.eaconnect.StartSetupJobResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.UploadEASourceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.UploadEASourceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.UploadEASourceRequest.displayName = 'proto.eaconnect.UploadEASourceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.StartCompileJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.StartCompileJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.StartCompileJobRequest.displayName = 'proto.eaconnect.StartCompileJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.GetCompileJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.GetCompileJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.GetCompileJobRequest.displayName = 'proto.eaconnect.GetCompileJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.CompileJob = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.CompileJob, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.CompileJob.displayName = 'proto.eaconnect.CompileJob';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.GetSettingsSchemaRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.GetSettingsSchemaRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.GetSettingsSchemaRequest.displayName = 'proto.eaconnect.GetSettingsSchemaRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.GetSettingsSchemaResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.GetSettingsSchemaResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.GetSettingsSchemaResponse.displayName = 'proto.eaconnect.GetSettingsSchemaResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.UploadSettingsSetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.UploadSettingsSetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.UploadSettingsSetRequest.displayName = 'proto.eaconnect.UploadSettingsSetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.SettingsSchemaResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.SettingsSchemaResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.SettingsSchemaResult.displayName = 'proto.eaconnect.SettingsSchemaResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.GetSetupJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.GetSetupJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.GetSetupJobRequest.displayName = 'proto.eaconnect.GetSetupJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.SetupJob = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.SetupJob, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.SetupJob.displayName = 'proto.eaconnect.SetupJob';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.Instance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.Instance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.Instance.displayName = 'proto.eaconnect.Instance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.InstanceRestartPolicy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.InstanceRestartPolicy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.InstanceRestartPolicy.displayName = 'proto.eaconnect.InstanceRestartPolicy';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.UpdateInstanceRestartPolicyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.UpdateInstanceRestartPolicyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.UpdateInstanceRestartPolicyRequest.displayName = 'proto.eaconnect.UpdateInstanceRestartPolicyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.CreateInstanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.CreateInstanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.CreateInstanceRequest.displayName = 'proto.eaconnect.CreateInstanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.TerminalOptions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.eaconnect.TerminalOptions.repeatedFields_, null);
};
goog.inherits(proto.eaconnect.TerminalOptions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.TerminalOptions.displayName = 'proto.eaconnect.TerminalOptions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.GetInstanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.GetInstanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.GetInstanceRequest.displayName = 'proto.eaconnect.GetInstanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.ListInstancesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.ListInstancesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.ListInstancesRequest.displayName = 'proto.eaconnect.ListInstancesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.ListInstancesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.eaconnect.ListInstancesResponse.repeatedFields_, null);
};
goog.inherits(proto.eaconnect.ListInstancesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.ListInstancesResponse.displayName = 'proto.eaconnect.ListInstancesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.DeleteInstanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.DeleteInstanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.DeleteInstanceRequest.displayName = 'proto.eaconnect.DeleteInstanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.StartInstanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.StartInstanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.StartInstanceRequest.displayName = 'proto.eaconnect.StartInstanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.StopInstanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.StopInstanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.StopInstanceRequest.displayName = 'proto.eaconnect.StopInstanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.RestartInstanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.RestartInstanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.RestartInstanceRequest.displayName = 'proto.eaconnect.RestartInstanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.SettingsVersion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.SettingsVersion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.SettingsVersion.displayName = 'proto.eaconnect.SettingsVersion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.UpdateSettingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.UpdateSettingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.UpdateSettingsRequest.displayName = 'proto.eaconnect.UpdateSettingsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.ListSettingsVersionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.ListSettingsVersionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.ListSettingsVersionsRequest.displayName = 'proto.eaconnect.ListSettingsVersionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.ListSettingsVersionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.eaconnect.ListSettingsVersionsResponse.repeatedFields_, null);
};
goog.inherits(proto.eaconnect.ListSettingsVersionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.ListSettingsVersionsResponse.displayName = 'proto.eaconnect.ListSettingsVersionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.RollbackSettingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.RollbackSettingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.RollbackSettingsRequest.displayName = 'proto.eaconnect.RollbackSettingsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.BrokerProfile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.BrokerProfile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.BrokerProfile.displayName = 'proto.eaconnect.BrokerProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.CreateBrokerProfileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.CreateBrokerProfileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.CreateBrokerProfileRequest.displayName = 'proto.eaconnect.CreateBrokerProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.ListBrokerProfilesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.ListBrokerProfilesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.ListBrokerProfilesRequest.displayName = 'proto.eaconnect.ListBrokerProfilesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.ListBrokerProfilesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.eaconnect.ListBrokerProfilesResponse.repeatedFields_, null);
};
goog.inherits(proto.eaconnect.ListBrokerProfilesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.ListBrokerProfilesResponse.displayName = 'proto.eaconnect.ListBrokerProfilesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.CheckBrokerProfileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.CheckBrokerProfileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.CheckBrokerProfileRequest.displayName = 'proto.eaconnect.CheckBrokerProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.CheckBrokerProfileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.CheckBrokerProfileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.CheckBrokerProfileResponse.displayName = 'proto.eaconnect.CheckBrokerProfileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.ValidateBrokerLoginRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.ValidateBrokerLoginRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.ValidateBrokerLoginRequest.displayName = 'proto.eaconnect.ValidateBrokerLoginRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.ValidateBrokerLoginResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.ValidateBrokerLoginResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.ValidateBrokerLoginResponse.displayName = 'proto.eaconnect.ValidateBrokerLoginResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.GetBrokerProfileSymbolsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.GetBrokerProfileSymbolsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.GetBrokerProfileSymbolsRequest.displayName = 'proto.eaconnect.GetBrokerProfileSymbolsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.GetBrokerProfileSymbolsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.eaconnect.GetBrokerProfileSymbolsResponse.repeatedFields_, null);
};
goog.inherits(proto.eaconnect.GetBrokerProfileSymbolsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.GetBrokerProfileSymbolsResponse.displayName = 'proto.eaconnect.GetBrokerProfileSymbolsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.UpdateBrokerProfileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.UpdateBrokerProfileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.UpdateBrokerProfileRequest.displayName = 'proto.eaconnect.UpdateBrokerProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.DeleteBrokerProfileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.DeleteBrokerProfileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.DeleteBrokerProfileRequest.displayName = 'proto.eaconnect.DeleteBrokerProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.InstanceStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.eaconnect.InstanceStatus.repeatedFields_, null);
};
goog.inherits(proto.eaconnect.InstanceStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.InstanceStatus.displayName = 'proto.eaconnect.InstanceStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.InstanceAutoRestartStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.InstanceAutoRestartStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.InstanceAutoRestartStatus.displayName = 'proto.eaconnect.InstanceAutoRestartStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.InstanceEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.InstanceEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.InstanceEvent.displayName = 'proto.eaconnect.InstanceEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.GetInstanceStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.GetInstanceStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.GetInstanceStatusRequest.displayName = 'proto.eaconnect.GetInstanceStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.GetInstanceMetricsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.GetInstanceMetricsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.GetInstanceMetricsRequest.displayName = 'proto.eaconnect.GetInstanceMetricsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.InstanceMetrics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.InstanceMetrics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.InstanceMetrics.displayName = 'proto.eaconnect.InstanceMetrics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.ListEquityHistoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.ListEquityHistoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.ListEquityHistoryRequest.displayName = 'proto.eaconnect.ListEquityHistoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.EquitySample = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.EquitySample, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.EquitySample.displayName = 'proto.eaconnect.EquitySample';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.ListEquityHistoryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.eaconnect.ListEquityHistoryResponse.repeatedFields_, null);
};
goog.inherits(proto.eaconnect.ListEquityHistoryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.ListEquityHistoryResponse.displayName = 'proto.eaconnect.ListEquityHistoryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.GetInstanceJournalRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.GetInstanceJournalRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.GetInstanceJournalRequest.displayName = 'proto.eaconnect.GetInstanceJournalRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.JournalLine = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.JournalLine, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.JournalLine.displayName = 'proto.eaconnect.JournalLine';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.GetInstanceJournalResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.eaconnect.GetInstanceJournalResponse.repeatedFields_, null);
};
goog.inherits(proto.eaconnect.GetInstanceJournalResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.GetInstanceJournalResponse.displayName = 'proto.eaconnect.GetInstanceJournalResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.GetHostingOverviewRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.GetHostingOverviewRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.GetHostingOverviewRequest.displayName = 'proto.eaconnect.GetHostingOverviewRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.HostingOverview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.HostingOverview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.HostingOverview.displayName = 'proto.eaconnect.HostingOverview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.ListUploadsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.ListUploadsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.ListUploadsRequest.displayName = 'proto.eaconnect.ListUploadsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.UploadEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.UploadEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.UploadEntry.displayName = 'proto.eaconnect.UploadEntry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.ListUploadsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.eaconnect.ListUploadsResponse.repeatedFields_, null);
};
goog.inherits(proto.eaconnect.ListUploadsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.ListUploadsResponse.displayName = 'proto.eaconnect.ListUploadsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.DismissUploadRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.DismissUploadRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.DismissUploadRequest.displayName = 'proto.eaconnect.DismissUploadRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.DismissUploadResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.DismissUploadResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.DismissUploadResponse.displayName = 'proto.eaconnect.DismissUploadResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.StreamLifecycleEventsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.eaconnect.StreamLifecycleEventsRequest.repeatedFields_, null);
};
goog.inherits(proto.eaconnect.StreamLifecycleEventsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.StreamLifecycleEventsRequest.displayName = 'proto.eaconnect.StreamLifecycleEventsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.LifecycleUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.LifecycleUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.LifecycleUpdate.displayName = 'proto.eaconnect.LifecycleUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.StreamInstanceLogsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.StreamInstanceLogsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.StreamInstanceLogsRequest.displayName = 'proto.eaconnect.StreamInstanceLogsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.LogStreamIdentity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.LogStreamIdentity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.LogStreamIdentity.displayName = 'proto.eaconnect.LogStreamIdentity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.StreamLogLine = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.StreamLogLine, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.StreamLogLine.displayName = 'proto.eaconnect.StreamLogLine';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.LogStreamClose = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.eaconnect.LogStreamClose, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.LogStreamClose.displayName = 'proto.eaconnect.LogStreamClose';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.eaconnect.LogStreamFrame = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.eaconnect.LogStreamFrame.oneofGroups_);
};
goog.inherits(proto.eaconnect.LogStreamFrame, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.eaconnect.LogStreamFrame.displayName = 'proto.eaconnect.LogStreamFrame';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.UploadEARequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.UploadEARequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.UploadEARequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.UploadEARequest.toObject = function(includeInstance, msg) {
  var f, obj = {
content: msg.getContent_asB64(),
filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
platform: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.UploadEARequest}
 */
proto.eaconnect.UploadEARequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.UploadEARequest;
  return proto.eaconnect.UploadEARequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.UploadEARequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.UploadEARequest}
 */
proto.eaconnect.UploadEARequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setContent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.UploadEARequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.UploadEARequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.UploadEARequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.UploadEARequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContent_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional bytes content = 1;
 * @return {!(string|Uint8Array)}
 */
proto.eaconnect.UploadEARequest.prototype.getContent = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes content = 1;
 * This is a type-conversion wrapper around `getContent()`
 * @return {string}
 */
proto.eaconnect.UploadEARequest.prototype.getContent_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getContent()));
};


/**
 * optional bytes content = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getContent()`
 * @return {!Uint8Array}
 */
proto.eaconnect.UploadEARequest.prototype.getContent_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getContent()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.eaconnect.UploadEARequest} returns this
 */
proto.eaconnect.UploadEARequest.prototype.setContent = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.eaconnect.UploadEARequest.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UploadEARequest} returns this
 */
proto.eaconnect.UploadEARequest.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string platform = 3;
 * @return {string}
 */
proto.eaconnect.UploadEARequest.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UploadEARequest} returns this
 */
proto.eaconnect.UploadEARequest.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.UploadEAResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.UploadEAResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.UploadEAResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.UploadEAResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
eaArtifactId: jspb.Message.getFieldWithDefault(msg, 1, ""),
sha256: jspb.Message.getFieldWithDefault(msg, 2, ""),
schemaStatus: jspb.Message.getFieldWithDefault(msg, 3, ""),
platform: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.UploadEAResponse}
 */
proto.eaconnect.UploadEAResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.UploadEAResponse;
  return proto.eaconnect.UploadEAResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.UploadEAResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.UploadEAResponse}
 */
proto.eaconnect.UploadEAResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEaArtifactId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSha256(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSchemaStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.UploadEAResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.UploadEAResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.UploadEAResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.UploadEAResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEaArtifactId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSha256();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSchemaStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string ea_artifact_id = 1;
 * @return {string}
 */
proto.eaconnect.UploadEAResponse.prototype.getEaArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UploadEAResponse} returns this
 */
proto.eaconnect.UploadEAResponse.prototype.setEaArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string sha256 = 2;
 * @return {string}
 */
proto.eaconnect.UploadEAResponse.prototype.getSha256 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UploadEAResponse} returns this
 */
proto.eaconnect.UploadEAResponse.prototype.setSha256 = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string schema_status = 3;
 * @return {string}
 */
proto.eaconnect.UploadEAResponse.prototype.getSchemaStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UploadEAResponse} returns this
 */
proto.eaconnect.UploadEAResponse.prototype.setSchemaStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string platform = 4;
 * @return {string}
 */
proto.eaconnect.UploadEAResponse.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UploadEAResponse} returns this
 */
proto.eaconnect.UploadEAResponse.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.eaconnect.StartSetupJobRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.StartSetupJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.StartSetupJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.StartSetupJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.StartSetupJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
eaArtifactId: jspb.Message.getFieldWithDefault(msg, 1, ""),
extractionMethodPreferencesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
preparationJobId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.StartSetupJobRequest}
 */
proto.eaconnect.StartSetupJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.StartSetupJobRequest;
  return proto.eaconnect.StartSetupJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.StartSetupJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.StartSetupJobRequest}
 */
proto.eaconnect.StartSetupJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEaArtifactId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addExtractionMethodPreferences(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreparationJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.StartSetupJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.StartSetupJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.StartSetupJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.StartSetupJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEaArtifactId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExtractionMethodPreferencesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getPreparationJobId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string ea_artifact_id = 1;
 * @return {string}
 */
proto.eaconnect.StartSetupJobRequest.prototype.getEaArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.StartSetupJobRequest} returns this
 */
proto.eaconnect.StartSetupJobRequest.prototype.setEaArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string extraction_method_preferences = 2;
 * @return {!Array<string>}
 */
proto.eaconnect.StartSetupJobRequest.prototype.getExtractionMethodPreferencesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.eaconnect.StartSetupJobRequest} returns this
 */
proto.eaconnect.StartSetupJobRequest.prototype.setExtractionMethodPreferencesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.eaconnect.StartSetupJobRequest} returns this
 */
proto.eaconnect.StartSetupJobRequest.prototype.addExtractionMethodPreferences = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.eaconnect.StartSetupJobRequest} returns this
 */
proto.eaconnect.StartSetupJobRequest.prototype.clearExtractionMethodPreferencesList = function() {
  return this.setExtractionMethodPreferencesList([]);
};


/**
 * optional string preparation_job_id = 3;
 * @return {string}
 */
proto.eaconnect.StartSetupJobRequest.prototype.getPreparationJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.StartSetupJobRequest} returns this
 */
proto.eaconnect.StartSetupJobRequest.prototype.setPreparationJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.StartSetupJobResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.StartSetupJobResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.StartSetupJobResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.StartSetupJobResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
status: jspb.Message.getFieldWithDefault(msg, 2, ""),
preparationJobId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.StartSetupJobResponse}
 */
proto.eaconnect.StartSetupJobResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.StartSetupJobResponse;
  return proto.eaconnect.StartSetupJobResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.StartSetupJobResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.StartSetupJobResponse}
 */
proto.eaconnect.StartSetupJobResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreparationJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.StartSetupJobResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.StartSetupJobResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.StartSetupJobResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.StartSetupJobResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPreparationJobId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.eaconnect.StartSetupJobResponse.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.StartSetupJobResponse} returns this
 */
proto.eaconnect.StartSetupJobResponse.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.eaconnect.StartSetupJobResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.StartSetupJobResponse} returns this
 */
proto.eaconnect.StartSetupJobResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string preparation_job_id = 3;
 * @return {string}
 */
proto.eaconnect.StartSetupJobResponse.prototype.getPreparationJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.StartSetupJobResponse} returns this
 */
proto.eaconnect.StartSetupJobResponse.prototype.setPreparationJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.UploadEASourceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.UploadEASourceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.UploadEASourceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.UploadEASourceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
content: msg.getContent_asB64(),
filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
platform: jspb.Message.getFieldWithDefault(msg, 3, ""),
idempotencyKey: jspb.Message.getFieldWithDefault(msg, 4, ""),
requestExtraction: (f = jspb.Message.getBooleanField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.UploadEASourceRequest}
 */
proto.eaconnect.UploadEASourceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.UploadEASourceRequest;
  return proto.eaconnect.UploadEASourceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.UploadEASourceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.UploadEASourceRequest}
 */
proto.eaconnect.UploadEASourceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setContent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdempotencyKey(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequestExtraction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.UploadEASourceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.UploadEASourceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.UploadEASourceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.UploadEASourceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContent_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIdempotencyKey();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional bytes content = 1;
 * @return {!(string|Uint8Array)}
 */
proto.eaconnect.UploadEASourceRequest.prototype.getContent = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes content = 1;
 * This is a type-conversion wrapper around `getContent()`
 * @return {string}
 */
proto.eaconnect.UploadEASourceRequest.prototype.getContent_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getContent()));
};


/**
 * optional bytes content = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getContent()`
 * @return {!Uint8Array}
 */
proto.eaconnect.UploadEASourceRequest.prototype.getContent_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getContent()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.eaconnect.UploadEASourceRequest} returns this
 */
proto.eaconnect.UploadEASourceRequest.prototype.setContent = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.eaconnect.UploadEASourceRequest.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UploadEASourceRequest} returns this
 */
proto.eaconnect.UploadEASourceRequest.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string platform = 3;
 * @return {string}
 */
proto.eaconnect.UploadEASourceRequest.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UploadEASourceRequest} returns this
 */
proto.eaconnect.UploadEASourceRequest.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string idempotency_key = 4;
 * @return {string}
 */
proto.eaconnect.UploadEASourceRequest.prototype.getIdempotencyKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UploadEASourceRequest} returns this
 */
proto.eaconnect.UploadEASourceRequest.prototype.setIdempotencyKey = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool request_extraction = 5;
 * @return {boolean}
 */
proto.eaconnect.UploadEASourceRequest.prototype.getRequestExtraction = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.UploadEASourceRequest} returns this
 */
proto.eaconnect.UploadEASourceRequest.prototype.setRequestExtraction = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.eaconnect.UploadEASourceRequest} returns this
 */
proto.eaconnect.UploadEASourceRequest.prototype.clearRequestExtraction = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.UploadEASourceRequest.prototype.hasRequestExtraction = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.StartCompileJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.StartCompileJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.StartCompileJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.StartCompileJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
sourceArtifactId: jspb.Message.getFieldWithDefault(msg, 1, ""),
idempotencyKey: jspb.Message.getFieldWithDefault(msg, 2, ""),
toolchainId: jspb.Message.getFieldWithDefault(msg, 3, ""),
requestExtraction: (f = jspb.Message.getBooleanField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.StartCompileJobRequest}
 */
proto.eaconnect.StartCompileJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.StartCompileJobRequest;
  return proto.eaconnect.StartCompileJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.StartCompileJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.StartCompileJobRequest}
 */
proto.eaconnect.StartCompileJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceArtifactId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdempotencyKey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setToolchainId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequestExtraction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.StartCompileJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.StartCompileJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.StartCompileJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.StartCompileJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSourceArtifactId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIdempotencyKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getToolchainId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string source_artifact_id = 1;
 * @return {string}
 */
proto.eaconnect.StartCompileJobRequest.prototype.getSourceArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.StartCompileJobRequest} returns this
 */
proto.eaconnect.StartCompileJobRequest.prototype.setSourceArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string idempotency_key = 2;
 * @return {string}
 */
proto.eaconnect.StartCompileJobRequest.prototype.getIdempotencyKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.StartCompileJobRequest} returns this
 */
proto.eaconnect.StartCompileJobRequest.prototype.setIdempotencyKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string toolchain_id = 3;
 * @return {string}
 */
proto.eaconnect.StartCompileJobRequest.prototype.getToolchainId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.StartCompileJobRequest} returns this
 */
proto.eaconnect.StartCompileJobRequest.prototype.setToolchainId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool request_extraction = 4;
 * @return {boolean}
 */
proto.eaconnect.StartCompileJobRequest.prototype.getRequestExtraction = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.StartCompileJobRequest} returns this
 */
proto.eaconnect.StartCompileJobRequest.prototype.setRequestExtraction = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.eaconnect.StartCompileJobRequest} returns this
 */
proto.eaconnect.StartCompileJobRequest.prototype.clearRequestExtraction = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.StartCompileJobRequest.prototype.hasRequestExtraction = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.GetCompileJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.GetCompileJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.GetCompileJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetCompileJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.GetCompileJobRequest}
 */
proto.eaconnect.GetCompileJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.GetCompileJobRequest;
  return proto.eaconnect.GetCompileJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.GetCompileJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.GetCompileJobRequest}
 */
proto.eaconnect.GetCompileJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.GetCompileJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.GetCompileJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.GetCompileJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetCompileJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.eaconnect.GetCompileJobRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.GetCompileJobRequest} returns this
 */
proto.eaconnect.GetCompileJobRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.CompileJob.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.CompileJob.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.CompileJob} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.CompileJob.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
sourceArtifactId: jspb.Message.getFieldWithDefault(msg, 2, ""),
sourceSha256: jspb.Message.getFieldWithDefault(msg, 3, ""),
filename: jspb.Message.getFieldWithDefault(msg, 4, ""),
platform: jspb.Message.getFieldWithDefault(msg, 5, ""),
status: jspb.Message.getFieldWithDefault(msg, 6, ""),
attempt: jspb.Message.getFieldWithDefault(msg, 7, 0),
maxAttempts: jspb.Message.getFieldWithDefault(msg, 8, 0),
failureCode: jspb.Message.getFieldWithDefault(msg, 9, ""),
error: jspb.Message.getFieldWithDefault(msg, 10, ""),
diagnostics: jspb.Message.getFieldWithDefault(msg, 11, ""),
toolchainId: jspb.Message.getFieldWithDefault(msg, 12, ""),
eaArtifactId: jspb.Message.getFieldWithDefault(msg, 13, ""),
binarySha256: jspb.Message.getFieldWithDefault(msg, 14, ""),
setupJobId: jspb.Message.getFieldWithDefault(msg, 15, ""),
setupStatus: jspb.Message.getFieldWithDefault(msg, 16, ""),
extractionRequested: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.CompileJob}
 */
proto.eaconnect.CompileJob.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.CompileJob;
  return proto.eaconnect.CompileJob.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.CompileJob} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.CompileJob}
 */
proto.eaconnect.CompileJob.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceArtifactId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceSha256(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAttempt(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMaxAttempts(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setFailureCode(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiagnostics(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setToolchainId(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setEaArtifactId(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setBinarySha256(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setSetupJobId(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setSetupStatus(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExtractionRequested(value);
      break;
    case 18:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 19:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.CompileJob.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.CompileJob.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.CompileJob} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.CompileJob.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSourceArtifactId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSourceSha256();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAttempt();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getMaxAttempts();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getFailureCode();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getDiagnostics();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getToolchainId();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getEaArtifactId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getBinarySha256();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getSetupJobId();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getSetupStatus();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getExtractionRequested();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.eaconnect.CompileJob.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CompileJob} returns this
 */
proto.eaconnect.CompileJob.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string source_artifact_id = 2;
 * @return {string}
 */
proto.eaconnect.CompileJob.prototype.getSourceArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CompileJob} returns this
 */
proto.eaconnect.CompileJob.prototype.setSourceArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string source_sha256 = 3;
 * @return {string}
 */
proto.eaconnect.CompileJob.prototype.getSourceSha256 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CompileJob} returns this
 */
proto.eaconnect.CompileJob.prototype.setSourceSha256 = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string filename = 4;
 * @return {string}
 */
proto.eaconnect.CompileJob.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CompileJob} returns this
 */
proto.eaconnect.CompileJob.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string platform = 5;
 * @return {string}
 */
proto.eaconnect.CompileJob.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CompileJob} returns this
 */
proto.eaconnect.CompileJob.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string status = 6;
 * @return {string}
 */
proto.eaconnect.CompileJob.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CompileJob} returns this
 */
proto.eaconnect.CompileJob.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional uint32 attempt = 7;
 * @return {number}
 */
proto.eaconnect.CompileJob.prototype.getAttempt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.CompileJob} returns this
 */
proto.eaconnect.CompileJob.prototype.setAttempt = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 max_attempts = 8;
 * @return {number}
 */
proto.eaconnect.CompileJob.prototype.getMaxAttempts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.CompileJob} returns this
 */
proto.eaconnect.CompileJob.prototype.setMaxAttempts = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string failure_code = 9;
 * @return {string}
 */
proto.eaconnect.CompileJob.prototype.getFailureCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CompileJob} returns this
 */
proto.eaconnect.CompileJob.prototype.setFailureCode = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string error = 10;
 * @return {string}
 */
proto.eaconnect.CompileJob.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CompileJob} returns this
 */
proto.eaconnect.CompileJob.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string diagnostics = 11;
 * @return {string}
 */
proto.eaconnect.CompileJob.prototype.getDiagnostics = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CompileJob} returns this
 */
proto.eaconnect.CompileJob.prototype.setDiagnostics = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string toolchain_id = 12;
 * @return {string}
 */
proto.eaconnect.CompileJob.prototype.getToolchainId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CompileJob} returns this
 */
proto.eaconnect.CompileJob.prototype.setToolchainId = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string ea_artifact_id = 13;
 * @return {string}
 */
proto.eaconnect.CompileJob.prototype.getEaArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CompileJob} returns this
 */
proto.eaconnect.CompileJob.prototype.setEaArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string binary_sha256 = 14;
 * @return {string}
 */
proto.eaconnect.CompileJob.prototype.getBinarySha256 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CompileJob} returns this
 */
proto.eaconnect.CompileJob.prototype.setBinarySha256 = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string setup_job_id = 15;
 * @return {string}
 */
proto.eaconnect.CompileJob.prototype.getSetupJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CompileJob} returns this
 */
proto.eaconnect.CompileJob.prototype.setSetupJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string setup_status = 16;
 * @return {string}
 */
proto.eaconnect.CompileJob.prototype.getSetupStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CompileJob} returns this
 */
proto.eaconnect.CompileJob.prototype.setSetupStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional bool extraction_requested = 17;
 * @return {boolean}
 */
proto.eaconnect.CompileJob.prototype.getExtractionRequested = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.CompileJob} returns this
 */
proto.eaconnect.CompileJob.prototype.setExtractionRequested = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 18;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.CompileJob.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 18));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.CompileJob} returns this
*/
proto.eaconnect.CompileJob.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.CompileJob} returns this
 */
proto.eaconnect.CompileJob.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.CompileJob.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 19;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.CompileJob.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 19));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.CompileJob} returns this
*/
proto.eaconnect.CompileJob.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.CompileJob} returns this
 */
proto.eaconnect.CompileJob.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.CompileJob.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 19) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.GetSettingsSchemaRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.GetSettingsSchemaRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.GetSettingsSchemaRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetSettingsSchemaRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
sha256: jspb.Message.getFieldWithDefault(msg, 1, ""),
instanceId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.GetSettingsSchemaRequest}
 */
proto.eaconnect.GetSettingsSchemaRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.GetSettingsSchemaRequest;
  return proto.eaconnect.GetSettingsSchemaRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.GetSettingsSchemaRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.GetSettingsSchemaRequest}
 */
proto.eaconnect.GetSettingsSchemaRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSha256(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstanceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.GetSettingsSchemaRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.GetSettingsSchemaRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.GetSettingsSchemaRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetSettingsSchemaRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSha256();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInstanceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string sha256 = 1;
 * @return {string}
 */
proto.eaconnect.GetSettingsSchemaRequest.prototype.getSha256 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.GetSettingsSchemaRequest} returns this
 */
proto.eaconnect.GetSettingsSchemaRequest.prototype.setSha256 = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string instance_id = 2;
 * @return {string}
 */
proto.eaconnect.GetSettingsSchemaRequest.prototype.getInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.GetSettingsSchemaRequest} returns this
 */
proto.eaconnect.GetSettingsSchemaRequest.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.GetSettingsSchemaResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.GetSettingsSchemaResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.GetSettingsSchemaResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetSettingsSchemaResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
sha256: jspb.Message.getFieldWithDefault(msg, 1, ""),
schemaJson: jspb.Message.getFieldWithDefault(msg, 2, ""),
status: jspb.Message.getFieldWithDefault(msg, 3, ""),
platform: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.GetSettingsSchemaResponse}
 */
proto.eaconnect.GetSettingsSchemaResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.GetSettingsSchemaResponse;
  return proto.eaconnect.GetSettingsSchemaResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.GetSettingsSchemaResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.GetSettingsSchemaResponse}
 */
proto.eaconnect.GetSettingsSchemaResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSha256(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSchemaJson(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.GetSettingsSchemaResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.GetSettingsSchemaResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.GetSettingsSchemaResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetSettingsSchemaResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSha256();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSchemaJson();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string sha256 = 1;
 * @return {string}
 */
proto.eaconnect.GetSettingsSchemaResponse.prototype.getSha256 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.GetSettingsSchemaResponse} returns this
 */
proto.eaconnect.GetSettingsSchemaResponse.prototype.setSha256 = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string schema_json = 2;
 * @return {string}
 */
proto.eaconnect.GetSettingsSchemaResponse.prototype.getSchemaJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.GetSettingsSchemaResponse} returns this
 */
proto.eaconnect.GetSettingsSchemaResponse.prototype.setSchemaJson = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string status = 3;
 * @return {string}
 */
proto.eaconnect.GetSettingsSchemaResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.GetSettingsSchemaResponse} returns this
 */
proto.eaconnect.GetSettingsSchemaResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string platform = 4;
 * @return {string}
 */
proto.eaconnect.GetSettingsSchemaResponse.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.GetSettingsSchemaResponse} returns this
 */
proto.eaconnect.GetSettingsSchemaResponse.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.UploadSettingsSetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.UploadSettingsSetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.UploadSettingsSetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.UploadSettingsSetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
eaArtifactId: jspb.Message.getFieldWithDefault(msg, 1, ""),
setBytes: msg.getSetBytes_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.UploadSettingsSetRequest}
 */
proto.eaconnect.UploadSettingsSetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.UploadSettingsSetRequest;
  return proto.eaconnect.UploadSettingsSetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.UploadSettingsSetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.UploadSettingsSetRequest}
 */
proto.eaconnect.UploadSettingsSetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEaArtifactId(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSetBytes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.UploadSettingsSetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.UploadSettingsSetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.UploadSettingsSetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.UploadSettingsSetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEaArtifactId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSetBytes_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional string ea_artifact_id = 1;
 * @return {string}
 */
proto.eaconnect.UploadSettingsSetRequest.prototype.getEaArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UploadSettingsSetRequest} returns this
 */
proto.eaconnect.UploadSettingsSetRequest.prototype.setEaArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes set_bytes = 2;
 * @return {!(string|Uint8Array)}
 */
proto.eaconnect.UploadSettingsSetRequest.prototype.getSetBytes = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes set_bytes = 2;
 * This is a type-conversion wrapper around `getSetBytes()`
 * @return {string}
 */
proto.eaconnect.UploadSettingsSetRequest.prototype.getSetBytes_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSetBytes()));
};


/**
 * optional bytes set_bytes = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSetBytes()`
 * @return {!Uint8Array}
 */
proto.eaconnect.UploadSettingsSetRequest.prototype.getSetBytes_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSetBytes()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.eaconnect.UploadSettingsSetRequest} returns this
 */
proto.eaconnect.UploadSettingsSetRequest.prototype.setSetBytes = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.SettingsSchemaResult.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.SettingsSchemaResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.SettingsSchemaResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.SettingsSchemaResult.toObject = function(includeInstance, msg) {
  var f, obj = {
sha256: jspb.Message.getFieldWithDefault(msg, 1, ""),
schemaJson: jspb.Message.getFieldWithDefault(msg, 2, ""),
status: jspb.Message.getFieldWithDefault(msg, 3, ""),
platform: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.SettingsSchemaResult}
 */
proto.eaconnect.SettingsSchemaResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.SettingsSchemaResult;
  return proto.eaconnect.SettingsSchemaResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.SettingsSchemaResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.SettingsSchemaResult}
 */
proto.eaconnect.SettingsSchemaResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSha256(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSchemaJson(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.SettingsSchemaResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.SettingsSchemaResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.SettingsSchemaResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.SettingsSchemaResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSha256();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSchemaJson();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string sha256 = 1;
 * @return {string}
 */
proto.eaconnect.SettingsSchemaResult.prototype.getSha256 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.SettingsSchemaResult} returns this
 */
proto.eaconnect.SettingsSchemaResult.prototype.setSha256 = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string schema_json = 2;
 * @return {string}
 */
proto.eaconnect.SettingsSchemaResult.prototype.getSchemaJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.SettingsSchemaResult} returns this
 */
proto.eaconnect.SettingsSchemaResult.prototype.setSchemaJson = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string status = 3;
 * @return {string}
 */
proto.eaconnect.SettingsSchemaResult.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.SettingsSchemaResult} returns this
 */
proto.eaconnect.SettingsSchemaResult.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string platform = 4;
 * @return {string}
 */
proto.eaconnect.SettingsSchemaResult.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.SettingsSchemaResult} returns this
 */
proto.eaconnect.SettingsSchemaResult.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.GetSetupJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.GetSetupJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.GetSetupJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetSetupJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.GetSetupJobRequest}
 */
proto.eaconnect.GetSetupJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.GetSetupJobRequest;
  return proto.eaconnect.GetSetupJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.GetSetupJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.GetSetupJobRequest}
 */
proto.eaconnect.GetSetupJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.GetSetupJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.GetSetupJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.GetSetupJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetSetupJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.eaconnect.GetSetupJobRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.GetSetupJobRequest} returns this
 */
proto.eaconnect.GetSetupJobRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.SetupJob.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.SetupJob.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.SetupJob} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.SetupJob.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
eaArtifactId: jspb.Message.getFieldWithDefault(msg, 2, ""),
sha256: jspb.Message.getFieldWithDefault(msg, 3, ""),
status: jspb.Message.getFieldWithDefault(msg, 4, ""),
methodUsed: jspb.Message.getFieldWithDefault(msg, 5, ""),
error: jspb.Message.getFieldWithDefault(msg, 6, ""),
platform: jspb.Message.getFieldWithDefault(msg, 7, ""),
preparationJobId: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.SetupJob}
 */
proto.eaconnect.SetupJob.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.SetupJob;
  return proto.eaconnect.SetupJob.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.SetupJob} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.SetupJob}
 */
proto.eaconnect.SetupJob.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEaArtifactId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSha256(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMethodUsed(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreparationJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.SetupJob.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.SetupJob.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.SetupJob} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.SetupJob.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEaArtifactId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSha256();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMethodUsed();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPreparationJobId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.eaconnect.SetupJob.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.SetupJob} returns this
 */
proto.eaconnect.SetupJob.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ea_artifact_id = 2;
 * @return {string}
 */
proto.eaconnect.SetupJob.prototype.getEaArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.SetupJob} returns this
 */
proto.eaconnect.SetupJob.prototype.setEaArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string sha256 = 3;
 * @return {string}
 */
proto.eaconnect.SetupJob.prototype.getSha256 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.SetupJob} returns this
 */
proto.eaconnect.SetupJob.prototype.setSha256 = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string status = 4;
 * @return {string}
 */
proto.eaconnect.SetupJob.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.SetupJob} returns this
 */
proto.eaconnect.SetupJob.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string method_used = 5;
 * @return {string}
 */
proto.eaconnect.SetupJob.prototype.getMethodUsed = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.SetupJob} returns this
 */
proto.eaconnect.SetupJob.prototype.setMethodUsed = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string error = 6;
 * @return {string}
 */
proto.eaconnect.SetupJob.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.SetupJob} returns this
 */
proto.eaconnect.SetupJob.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string platform = 7;
 * @return {string}
 */
proto.eaconnect.SetupJob.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.SetupJob} returns this
 */
proto.eaconnect.SetupJob.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string preparation_job_id = 8;
 * @return {string}
 */
proto.eaconnect.SetupJob.prototype.getPreparationJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.SetupJob} returns this
 */
proto.eaconnect.SetupJob.prototype.setPreparationJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.Instance.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.Instance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.Instance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.Instance.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
eaArtifactId: jspb.Message.getFieldWithDefault(msg, 3, ""),
brokerProfileId: jspb.Message.getFieldWithDefault(msg, 4, ""),
name: jspb.Message.getFieldWithDefault(msg, 5, ""),
symbol: jspb.Message.getFieldWithDefault(msg, 6, ""),
timeframe: jspb.Message.getFieldWithDefault(msg, 7, ""),
status: jspb.Message.getFieldWithDefault(msg, 8, ""),
currentSettingsVersion: jspb.Message.getFieldWithDefault(msg, 9, 0),
tier: jspb.Message.getFieldWithDefault(msg, 10, ""),
assignedPod: jspb.Message.getFieldWithDefault(msg, 13, ""),
assignedSlot: jspb.Message.getFieldWithDefault(msg, 14, 0),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
startedAt: (f = msg.getStartedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
stoppedAt: (f = msg.getStoppedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
platform: jspb.Message.getFieldWithDefault(msg, 18, ""),
allowDllImport: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
restartPolicy: (f = msg.getRestartPolicy()) && proto.eaconnect.InstanceRestartPolicy.toObject(includeInstance, f),
desiredSettingsVersion: jspb.Message.getFieldWithDefault(msg, 22, 0),
desiredState: jspb.Message.getFieldWithDefault(msg, 25, ""),
terminalOptions: (f = msg.getTerminalOptions()) && proto.eaconnect.TerminalOptions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.Instance}
 */
proto.eaconnect.Instance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.Instance;
  return proto.eaconnect.Instance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.Instance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.Instance}
 */
proto.eaconnect.Instance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEaArtifactId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerProfileId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeframe(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrentSettingsVersion(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setTier(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignedPod(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAssignedSlot(value);
      break;
    case 15:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 16:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartedAt(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStoppedAt(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowDllImport(value);
      break;
    case 21:
      var value = new proto.eaconnect.InstanceRestartPolicy;
      reader.readMessage(value,proto.eaconnect.InstanceRestartPolicy.deserializeBinaryFromReader);
      msg.setRestartPolicy(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDesiredSettingsVersion(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setDesiredState(value);
      break;
    case 28:
      var value = new proto.eaconnect.TerminalOptions;
      reader.readMessage(value,proto.eaconnect.TerminalOptions.deserializeBinaryFromReader);
      msg.setTerminalOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.Instance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.Instance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.Instance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.Instance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEaArtifactId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBrokerProfileId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTimeframe();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCurrentSettingsVersion();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getTier();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getAssignedPod();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getAssignedSlot();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStartedAt();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStoppedAt();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getAllowDllImport();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getRestartPolicy();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.eaconnect.InstanceRestartPolicy.serializeBinaryToWriter
    );
  }
  f = message.getDesiredSettingsVersion();
  if (f !== 0) {
    writer.writeInt32(
      22,
      f
    );
  }
  f = message.getDesiredState();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getTerminalOptions();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      proto.eaconnect.TerminalOptions.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.eaconnect.Instance.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.Instance} returns this
 */
proto.eaconnect.Instance.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.eaconnect.Instance.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.Instance} returns this
 */
proto.eaconnect.Instance.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ea_artifact_id = 3;
 * @return {string}
 */
proto.eaconnect.Instance.prototype.getEaArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.Instance} returns this
 */
proto.eaconnect.Instance.prototype.setEaArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string broker_profile_id = 4;
 * @return {string}
 */
proto.eaconnect.Instance.prototype.getBrokerProfileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.Instance} returns this
 */
proto.eaconnect.Instance.prototype.setBrokerProfileId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string name = 5;
 * @return {string}
 */
proto.eaconnect.Instance.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.Instance} returns this
 */
proto.eaconnect.Instance.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string symbol = 6;
 * @return {string}
 */
proto.eaconnect.Instance.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.Instance} returns this
 */
proto.eaconnect.Instance.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string timeframe = 7;
 * @return {string}
 */
proto.eaconnect.Instance.prototype.getTimeframe = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.Instance} returns this
 */
proto.eaconnect.Instance.prototype.setTimeframe = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string status = 8;
 * @return {string}
 */
proto.eaconnect.Instance.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.Instance} returns this
 */
proto.eaconnect.Instance.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 current_settings_version = 9;
 * @return {number}
 */
proto.eaconnect.Instance.prototype.getCurrentSettingsVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.Instance} returns this
 */
proto.eaconnect.Instance.prototype.setCurrentSettingsVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string tier = 10;
 * @return {string}
 */
proto.eaconnect.Instance.prototype.getTier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.Instance} returns this
 */
proto.eaconnect.Instance.prototype.setTier = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string assigned_pod = 13;
 * @return {string}
 */
proto.eaconnect.Instance.prototype.getAssignedPod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.Instance} returns this
 */
proto.eaconnect.Instance.prototype.setAssignedPod = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int32 assigned_slot = 14;
 * @return {number}
 */
proto.eaconnect.Instance.prototype.getAssignedSlot = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.Instance} returns this
 */
proto.eaconnect.Instance.prototype.setAssignedSlot = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 15;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.Instance.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 15));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.Instance} returns this
*/
proto.eaconnect.Instance.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.Instance} returns this
 */
proto.eaconnect.Instance.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.Instance.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.Timestamp started_at = 16;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.Instance.prototype.getStartedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 16));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.Instance} returns this
*/
proto.eaconnect.Instance.prototype.setStartedAt = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.Instance} returns this
 */
proto.eaconnect.Instance.prototype.clearStartedAt = function() {
  return this.setStartedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.Instance.prototype.hasStartedAt = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.Timestamp stopped_at = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.Instance.prototype.getStoppedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.Instance} returns this
*/
proto.eaconnect.Instance.prototype.setStoppedAt = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.Instance} returns this
 */
proto.eaconnect.Instance.prototype.clearStoppedAt = function() {
  return this.setStoppedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.Instance.prototype.hasStoppedAt = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional string platform = 18;
 * @return {string}
 */
proto.eaconnect.Instance.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.Instance} returns this
 */
proto.eaconnect.Instance.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional bool allow_dll_import = 20;
 * @return {boolean}
 */
proto.eaconnect.Instance.prototype.getAllowDllImport = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.Instance} returns this
 */
proto.eaconnect.Instance.prototype.setAllowDllImport = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional InstanceRestartPolicy restart_policy = 21;
 * @return {?proto.eaconnect.InstanceRestartPolicy}
 */
proto.eaconnect.Instance.prototype.getRestartPolicy = function() {
  return /** @type{?proto.eaconnect.InstanceRestartPolicy} */ (
    jspb.Message.getWrapperField(this, proto.eaconnect.InstanceRestartPolicy, 21));
};


/**
 * @param {?proto.eaconnect.InstanceRestartPolicy|undefined} value
 * @return {!proto.eaconnect.Instance} returns this
*/
proto.eaconnect.Instance.prototype.setRestartPolicy = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.Instance} returns this
 */
proto.eaconnect.Instance.prototype.clearRestartPolicy = function() {
  return this.setRestartPolicy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.Instance.prototype.hasRestartPolicy = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional int32 desired_settings_version = 22;
 * @return {number}
 */
proto.eaconnect.Instance.prototype.getDesiredSettingsVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.Instance} returns this
 */
proto.eaconnect.Instance.prototype.setDesiredSettingsVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional string desired_state = 25;
 * @return {string}
 */
proto.eaconnect.Instance.prototype.getDesiredState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.Instance} returns this
 */
proto.eaconnect.Instance.prototype.setDesiredState = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional TerminalOptions terminal_options = 28;
 * @return {?proto.eaconnect.TerminalOptions}
 */
proto.eaconnect.Instance.prototype.getTerminalOptions = function() {
  return /** @type{?proto.eaconnect.TerminalOptions} */ (
    jspb.Message.getWrapperField(this, proto.eaconnect.TerminalOptions, 28));
};


/**
 * @param {?proto.eaconnect.TerminalOptions|undefined} value
 * @return {!proto.eaconnect.Instance} returns this
*/
proto.eaconnect.Instance.prototype.setTerminalOptions = function(value) {
  return jspb.Message.setWrapperField(this, 28, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.Instance} returns this
 */
proto.eaconnect.Instance.prototype.clearTerminalOptions = function() {
  return this.setTerminalOptions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.Instance.prototype.hasTerminalOptions = function() {
  return jspb.Message.getField(this, 28) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.InstanceRestartPolicy.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.InstanceRestartPolicy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.InstanceRestartPolicy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.InstanceRestartPolicy.toObject = function(includeInstance, msg) {
  var f, obj = {
autoRestart: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
maxRestartsPer24h: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.InstanceRestartPolicy}
 */
proto.eaconnect.InstanceRestartPolicy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.InstanceRestartPolicy;
  return proto.eaconnect.InstanceRestartPolicy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.InstanceRestartPolicy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.InstanceRestartPolicy}
 */
proto.eaconnect.InstanceRestartPolicy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutoRestart(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMaxRestartsPer24h(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.InstanceRestartPolicy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.InstanceRestartPolicy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.InstanceRestartPolicy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.InstanceRestartPolicy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAutoRestart();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMaxRestartsPer24h();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional bool auto_restart = 1;
 * @return {boolean}
 */
proto.eaconnect.InstanceRestartPolicy.prototype.getAutoRestart = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.InstanceRestartPolicy} returns this
 */
proto.eaconnect.InstanceRestartPolicy.prototype.setAutoRestart = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional uint32 max_restarts_per_24h = 2;
 * @return {number}
 */
proto.eaconnect.InstanceRestartPolicy.prototype.getMaxRestartsPer24h = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceRestartPolicy} returns this
 */
proto.eaconnect.InstanceRestartPolicy.prototype.setMaxRestartsPer24h = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.UpdateInstanceRestartPolicyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.UpdateInstanceRestartPolicyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.UpdateInstanceRestartPolicyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.UpdateInstanceRestartPolicyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
instanceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
restartPolicy: (f = msg.getRestartPolicy()) && proto.eaconnect.InstanceRestartPolicy.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.UpdateInstanceRestartPolicyRequest}
 */
proto.eaconnect.UpdateInstanceRestartPolicyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.UpdateInstanceRestartPolicyRequest;
  return proto.eaconnect.UpdateInstanceRestartPolicyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.UpdateInstanceRestartPolicyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.UpdateInstanceRestartPolicyRequest}
 */
proto.eaconnect.UpdateInstanceRestartPolicyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstanceId(value);
      break;
    case 2:
      var value = new proto.eaconnect.InstanceRestartPolicy;
      reader.readMessage(value,proto.eaconnect.InstanceRestartPolicy.deserializeBinaryFromReader);
      msg.setRestartPolicy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.UpdateInstanceRestartPolicyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.UpdateInstanceRestartPolicyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.UpdateInstanceRestartPolicyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.UpdateInstanceRestartPolicyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstanceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRestartPolicy();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.eaconnect.InstanceRestartPolicy.serializeBinaryToWriter
    );
  }
};


/**
 * optional string instance_id = 1;
 * @return {string}
 */
proto.eaconnect.UpdateInstanceRestartPolicyRequest.prototype.getInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UpdateInstanceRestartPolicyRequest} returns this
 */
proto.eaconnect.UpdateInstanceRestartPolicyRequest.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional InstanceRestartPolicy restart_policy = 2;
 * @return {?proto.eaconnect.InstanceRestartPolicy}
 */
proto.eaconnect.UpdateInstanceRestartPolicyRequest.prototype.getRestartPolicy = function() {
  return /** @type{?proto.eaconnect.InstanceRestartPolicy} */ (
    jspb.Message.getWrapperField(this, proto.eaconnect.InstanceRestartPolicy, 2));
};


/**
 * @param {?proto.eaconnect.InstanceRestartPolicy|undefined} value
 * @return {!proto.eaconnect.UpdateInstanceRestartPolicyRequest} returns this
*/
proto.eaconnect.UpdateInstanceRestartPolicyRequest.prototype.setRestartPolicy = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.UpdateInstanceRestartPolicyRequest} returns this
 */
proto.eaconnect.UpdateInstanceRestartPolicyRequest.prototype.clearRestartPolicy = function() {
  return this.setRestartPolicy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.UpdateInstanceRestartPolicyRequest.prototype.hasRestartPolicy = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.CreateInstanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.CreateInstanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.CreateInstanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.CreateInstanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
eaArtifactId: jspb.Message.getFieldWithDefault(msg, 2, ""),
brokerProfileId: jspb.Message.getFieldWithDefault(msg, 3, ""),
name: jspb.Message.getFieldWithDefault(msg, 4, ""),
symbol: jspb.Message.getFieldWithDefault(msg, 5, ""),
timeframe: jspb.Message.getFieldWithDefault(msg, 6, ""),
settings: (f = msg.getSettings()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
tier: jspb.Message.getFieldWithDefault(msg, 8, ""),
idempotencyKey: jspb.Message.getFieldWithDefault(msg, 9, ""),
allowDllImport: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
terminalOptions: (f = msg.getTerminalOptions()) && proto.eaconnect.TerminalOptions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.CreateInstanceRequest}
 */
proto.eaconnect.CreateInstanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.CreateInstanceRequest;
  return proto.eaconnect.CreateInstanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.CreateInstanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.CreateInstanceRequest}
 */
proto.eaconnect.CreateInstanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEaArtifactId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerProfileId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeframe(value);
      break;
    case 7:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setSettings(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTier(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdempotencyKey(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowDllImport(value);
      break;
    case 13:
      var value = new proto.eaconnect.TerminalOptions;
      reader.readMessage(value,proto.eaconnect.TerminalOptions.deserializeBinaryFromReader);
      msg.setTerminalOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.CreateInstanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.CreateInstanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.CreateInstanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.CreateInstanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEaArtifactId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBrokerProfileId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTimeframe();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSettings();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getTier();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getIdempotencyKey();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAllowDllImport();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getTerminalOptions();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.eaconnect.TerminalOptions.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.eaconnect.CreateInstanceRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CreateInstanceRequest} returns this
 */
proto.eaconnect.CreateInstanceRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ea_artifact_id = 2;
 * @return {string}
 */
proto.eaconnect.CreateInstanceRequest.prototype.getEaArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CreateInstanceRequest} returns this
 */
proto.eaconnect.CreateInstanceRequest.prototype.setEaArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string broker_profile_id = 3;
 * @return {string}
 */
proto.eaconnect.CreateInstanceRequest.prototype.getBrokerProfileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CreateInstanceRequest} returns this
 */
proto.eaconnect.CreateInstanceRequest.prototype.setBrokerProfileId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.eaconnect.CreateInstanceRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CreateInstanceRequest} returns this
 */
proto.eaconnect.CreateInstanceRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string symbol = 5;
 * @return {string}
 */
proto.eaconnect.CreateInstanceRequest.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CreateInstanceRequest} returns this
 */
proto.eaconnect.CreateInstanceRequest.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string timeframe = 6;
 * @return {string}
 */
proto.eaconnect.CreateInstanceRequest.prototype.getTimeframe = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CreateInstanceRequest} returns this
 */
proto.eaconnect.CreateInstanceRequest.prototype.setTimeframe = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional google.protobuf.Struct settings = 7;
 * @return {?proto.google.protobuf.Struct}
 */
proto.eaconnect.CreateInstanceRequest.prototype.getSettings = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 7));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.eaconnect.CreateInstanceRequest} returns this
*/
proto.eaconnect.CreateInstanceRequest.prototype.setSettings = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.CreateInstanceRequest} returns this
 */
proto.eaconnect.CreateInstanceRequest.prototype.clearSettings = function() {
  return this.setSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.CreateInstanceRequest.prototype.hasSettings = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string tier = 8;
 * @return {string}
 */
proto.eaconnect.CreateInstanceRequest.prototype.getTier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CreateInstanceRequest} returns this
 */
proto.eaconnect.CreateInstanceRequest.prototype.setTier = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string idempotency_key = 9;
 * @return {string}
 */
proto.eaconnect.CreateInstanceRequest.prototype.getIdempotencyKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CreateInstanceRequest} returns this
 */
proto.eaconnect.CreateInstanceRequest.prototype.setIdempotencyKey = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool allow_dll_import = 10;
 * @return {boolean}
 */
proto.eaconnect.CreateInstanceRequest.prototype.getAllowDllImport = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.CreateInstanceRequest} returns this
 */
proto.eaconnect.CreateInstanceRequest.prototype.setAllowDllImport = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional TerminalOptions terminal_options = 13;
 * @return {?proto.eaconnect.TerminalOptions}
 */
proto.eaconnect.CreateInstanceRequest.prototype.getTerminalOptions = function() {
  return /** @type{?proto.eaconnect.TerminalOptions} */ (
    jspb.Message.getWrapperField(this, proto.eaconnect.TerminalOptions, 13));
};


/**
 * @param {?proto.eaconnect.TerminalOptions|undefined} value
 * @return {!proto.eaconnect.CreateInstanceRequest} returns this
*/
proto.eaconnect.CreateInstanceRequest.prototype.setTerminalOptions = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.CreateInstanceRequest} returns this
 */
proto.eaconnect.CreateInstanceRequest.prototype.clearTerminalOptions = function() {
  return this.setTerminalOptions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.CreateInstanceRequest.prototype.hasTerminalOptions = function() {
  return jspb.Message.getField(this, 13) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.eaconnect.TerminalOptions.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.TerminalOptions.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.TerminalOptions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.TerminalOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.TerminalOptions.toObject = function(includeInstance, msg) {
  var f, obj = {
maxBars: jspb.Message.getFieldWithDefault(msg, 1, 0),
chartShow: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
allowDllImport: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
allowedUrlsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
allowedUrlCount: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.TerminalOptions}
 */
proto.eaconnect.TerminalOptions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.TerminalOptions;
  return proto.eaconnect.TerminalOptions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.TerminalOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.TerminalOptions}
 */
proto.eaconnect.TerminalOptions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMaxBars(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setChartShow(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowDllImport(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addAllowedUrls(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAllowedUrlCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.TerminalOptions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.TerminalOptions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.TerminalOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.TerminalOptions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMaxBars();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getChartShow();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getAllowDllImport();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getAllowedUrlsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getAllowedUrlCount();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
};


/**
 * optional uint32 max_bars = 1;
 * @return {number}
 */
proto.eaconnect.TerminalOptions.prototype.getMaxBars = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.TerminalOptions} returns this
 */
proto.eaconnect.TerminalOptions.prototype.setMaxBars = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool chart_show = 2;
 * @return {boolean}
 */
proto.eaconnect.TerminalOptions.prototype.getChartShow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.TerminalOptions} returns this
 */
proto.eaconnect.TerminalOptions.prototype.setChartShow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool allow_dll_import = 3;
 * @return {boolean}
 */
proto.eaconnect.TerminalOptions.prototype.getAllowDllImport = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.TerminalOptions} returns this
 */
proto.eaconnect.TerminalOptions.prototype.setAllowDllImport = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * repeated string allowed_urls = 4;
 * @return {!Array<string>}
 */
proto.eaconnect.TerminalOptions.prototype.getAllowedUrlsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.eaconnect.TerminalOptions} returns this
 */
proto.eaconnect.TerminalOptions.prototype.setAllowedUrlsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.eaconnect.TerminalOptions} returns this
 */
proto.eaconnect.TerminalOptions.prototype.addAllowedUrls = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.eaconnect.TerminalOptions} returns this
 */
proto.eaconnect.TerminalOptions.prototype.clearAllowedUrlsList = function() {
  return this.setAllowedUrlsList([]);
};


/**
 * optional uint32 allowed_url_count = 5;
 * @return {number}
 */
proto.eaconnect.TerminalOptions.prototype.getAllowedUrlCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.TerminalOptions} returns this
 */
proto.eaconnect.TerminalOptions.prototype.setAllowedUrlCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.GetInstanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.GetInstanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.GetInstanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetInstanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.GetInstanceRequest}
 */
proto.eaconnect.GetInstanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.GetInstanceRequest;
  return proto.eaconnect.GetInstanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.GetInstanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.GetInstanceRequest}
 */
proto.eaconnect.GetInstanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.GetInstanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.GetInstanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.GetInstanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetInstanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.eaconnect.GetInstanceRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.GetInstanceRequest} returns this
 */
proto.eaconnect.GetInstanceRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.ListInstancesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.ListInstancesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.ListInstancesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ListInstancesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
status: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
page: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.ListInstancesRequest}
 */
proto.eaconnect.ListInstancesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.ListInstancesRequest;
  return proto.eaconnect.ListInstancesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.ListInstancesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.ListInstancesRequest}
 */
proto.eaconnect.ListInstancesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.ListInstancesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.ListInstancesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.ListInstancesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ListInstancesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.eaconnect.ListInstancesRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.ListInstancesRequest} returns this
 */
proto.eaconnect.ListInstancesRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.eaconnect.ListInstancesRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.ListInstancesRequest} returns this
 */
proto.eaconnect.ListInstancesRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.eaconnect.ListInstancesRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.ListInstancesRequest} returns this
 */
proto.eaconnect.ListInstancesRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 page = 4;
 * @return {number}
 */
proto.eaconnect.ListInstancesRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.ListInstancesRequest} returns this
 */
proto.eaconnect.ListInstancesRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.eaconnect.ListInstancesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.ListInstancesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.ListInstancesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.ListInstancesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ListInstancesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
instancesList: jspb.Message.toObjectList(msg.getInstancesList(),
    proto.eaconnect.Instance.toObject, includeInstance),
total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.ListInstancesResponse}
 */
proto.eaconnect.ListInstancesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.ListInstancesResponse;
  return proto.eaconnect.ListInstancesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.ListInstancesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.ListInstancesResponse}
 */
proto.eaconnect.ListInstancesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.eaconnect.Instance;
      reader.readMessage(value,proto.eaconnect.Instance.deserializeBinaryFromReader);
      msg.addInstances(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.ListInstancesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.ListInstancesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.ListInstancesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ListInstancesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstancesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.eaconnect.Instance.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * repeated Instance instances = 1;
 * @return {!Array<!proto.eaconnect.Instance>}
 */
proto.eaconnect.ListInstancesResponse.prototype.getInstancesList = function() {
  return /** @type{!Array<!proto.eaconnect.Instance>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.eaconnect.Instance, 1));
};


/**
 * @param {!Array<!proto.eaconnect.Instance>} value
 * @return {!proto.eaconnect.ListInstancesResponse} returns this
*/
proto.eaconnect.ListInstancesResponse.prototype.setInstancesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.eaconnect.Instance=} opt_value
 * @param {number=} opt_index
 * @return {!proto.eaconnect.Instance}
 */
proto.eaconnect.ListInstancesResponse.prototype.addInstances = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.eaconnect.Instance, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.eaconnect.ListInstancesResponse} returns this
 */
proto.eaconnect.ListInstancesResponse.prototype.clearInstancesList = function() {
  return this.setInstancesList([]);
};


/**
 * optional int64 total = 2;
 * @return {number}
 */
proto.eaconnect.ListInstancesResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.ListInstancesResponse} returns this
 */
proto.eaconnect.ListInstancesResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.DeleteInstanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.DeleteInstanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.DeleteInstanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.DeleteInstanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.DeleteInstanceRequest}
 */
proto.eaconnect.DeleteInstanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.DeleteInstanceRequest;
  return proto.eaconnect.DeleteInstanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.DeleteInstanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.DeleteInstanceRequest}
 */
proto.eaconnect.DeleteInstanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.DeleteInstanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.DeleteInstanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.DeleteInstanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.DeleteInstanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.eaconnect.DeleteInstanceRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.DeleteInstanceRequest} returns this
 */
proto.eaconnect.DeleteInstanceRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.StartInstanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.StartInstanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.StartInstanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.StartInstanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
idempotencyKey: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.StartInstanceRequest}
 */
proto.eaconnect.StartInstanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.StartInstanceRequest;
  return proto.eaconnect.StartInstanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.StartInstanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.StartInstanceRequest}
 */
proto.eaconnect.StartInstanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdempotencyKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.StartInstanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.StartInstanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.StartInstanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.StartInstanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIdempotencyKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.eaconnect.StartInstanceRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.StartInstanceRequest} returns this
 */
proto.eaconnect.StartInstanceRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string idempotency_key = 2;
 * @return {string}
 */
proto.eaconnect.StartInstanceRequest.prototype.getIdempotencyKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.StartInstanceRequest} returns this
 */
proto.eaconnect.StartInstanceRequest.prototype.setIdempotencyKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.StopInstanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.StopInstanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.StopInstanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.StopInstanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
idempotencyKey: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.StopInstanceRequest}
 */
proto.eaconnect.StopInstanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.StopInstanceRequest;
  return proto.eaconnect.StopInstanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.StopInstanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.StopInstanceRequest}
 */
proto.eaconnect.StopInstanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdempotencyKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.StopInstanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.StopInstanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.StopInstanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.StopInstanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIdempotencyKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.eaconnect.StopInstanceRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.StopInstanceRequest} returns this
 */
proto.eaconnect.StopInstanceRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string idempotency_key = 2;
 * @return {string}
 */
proto.eaconnect.StopInstanceRequest.prototype.getIdempotencyKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.StopInstanceRequest} returns this
 */
proto.eaconnect.StopInstanceRequest.prototype.setIdempotencyKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.RestartInstanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.RestartInstanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.RestartInstanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.RestartInstanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
idempotencyKey: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.RestartInstanceRequest}
 */
proto.eaconnect.RestartInstanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.RestartInstanceRequest;
  return proto.eaconnect.RestartInstanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.RestartInstanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.RestartInstanceRequest}
 */
proto.eaconnect.RestartInstanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdempotencyKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.RestartInstanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.RestartInstanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.RestartInstanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.RestartInstanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIdempotencyKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.eaconnect.RestartInstanceRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.RestartInstanceRequest} returns this
 */
proto.eaconnect.RestartInstanceRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string idempotency_key = 2;
 * @return {string}
 */
proto.eaconnect.RestartInstanceRequest.prototype.getIdempotencyKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.RestartInstanceRequest} returns this
 */
proto.eaconnect.RestartInstanceRequest.prototype.setIdempotencyKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.SettingsVersion.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.SettingsVersion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.SettingsVersion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.SettingsVersion.toObject = function(includeInstance, msg) {
  var f, obj = {
instanceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
version: jspb.Message.getFieldWithDefault(msg, 2, 0),
values: (f = msg.getValues()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
status: jspb.Message.getFieldWithDefault(msg, 4, ""),
applyError: jspb.Message.getFieldWithDefault(msg, 5, ""),
appliedAt: (f = msg.getAppliedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.SettingsVersion}
 */
proto.eaconnect.SettingsVersion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.SettingsVersion;
  return proto.eaconnect.SettingsVersion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.SettingsVersion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.SettingsVersion}
 */
proto.eaconnect.SettingsVersion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstanceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 3:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setValues(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplyError(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setAppliedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.SettingsVersion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.SettingsVersion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.SettingsVersion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.SettingsVersion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstanceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getValues();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getApplyError();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAppliedAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string instance_id = 1;
 * @return {string}
 */
proto.eaconnect.SettingsVersion.prototype.getInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.SettingsVersion} returns this
 */
proto.eaconnect.SettingsVersion.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 version = 2;
 * @return {number}
 */
proto.eaconnect.SettingsVersion.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.SettingsVersion} returns this
 */
proto.eaconnect.SettingsVersion.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.protobuf.Struct values = 3;
 * @return {?proto.google.protobuf.Struct}
 */
proto.eaconnect.SettingsVersion.prototype.getValues = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 3));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.eaconnect.SettingsVersion} returns this
*/
proto.eaconnect.SettingsVersion.prototype.setValues = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.SettingsVersion} returns this
 */
proto.eaconnect.SettingsVersion.prototype.clearValues = function() {
  return this.setValues(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.SettingsVersion.prototype.hasValues = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string status = 4;
 * @return {string}
 */
proto.eaconnect.SettingsVersion.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.SettingsVersion} returns this
 */
proto.eaconnect.SettingsVersion.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string apply_error = 5;
 * @return {string}
 */
proto.eaconnect.SettingsVersion.prototype.getApplyError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.SettingsVersion} returns this
 */
proto.eaconnect.SettingsVersion.prototype.setApplyError = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp applied_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.SettingsVersion.prototype.getAppliedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.SettingsVersion} returns this
*/
proto.eaconnect.SettingsVersion.prototype.setAppliedAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.SettingsVersion} returns this
 */
proto.eaconnect.SettingsVersion.prototype.clearAppliedAt = function() {
  return this.setAppliedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.SettingsVersion.prototype.hasAppliedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.UpdateSettingsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.UpdateSettingsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.UpdateSettingsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.UpdateSettingsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
instanceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
previousVersion: jspb.Message.getFieldWithDefault(msg, 2, 0),
settings: (f = msg.getSettings()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
appliedByUser: jspb.Message.getFieldWithDefault(msg, 4, ""),
idempotencyKey: jspb.Message.getFieldWithDefault(msg, 5, ""),
expectedDesiredSettingsVersion: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.UpdateSettingsRequest}
 */
proto.eaconnect.UpdateSettingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.UpdateSettingsRequest;
  return proto.eaconnect.UpdateSettingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.UpdateSettingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.UpdateSettingsRequest}
 */
proto.eaconnect.UpdateSettingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstanceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPreviousVersion(value);
      break;
    case 3:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setSettings(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppliedByUser(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdempotencyKey(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExpectedDesiredSettingsVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.UpdateSettingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.UpdateSettingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.UpdateSettingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.UpdateSettingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstanceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPreviousVersion();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSettings();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getAppliedByUser();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIdempotencyKey();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional string instance_id = 1;
 * @return {string}
 */
proto.eaconnect.UpdateSettingsRequest.prototype.getInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UpdateSettingsRequest} returns this
 */
proto.eaconnect.UpdateSettingsRequest.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 previous_version = 2;
 * @return {number}
 */
proto.eaconnect.UpdateSettingsRequest.prototype.getPreviousVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.UpdateSettingsRequest} returns this
 */
proto.eaconnect.UpdateSettingsRequest.prototype.setPreviousVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.protobuf.Struct settings = 3;
 * @return {?proto.google.protobuf.Struct}
 */
proto.eaconnect.UpdateSettingsRequest.prototype.getSettings = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 3));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.eaconnect.UpdateSettingsRequest} returns this
*/
proto.eaconnect.UpdateSettingsRequest.prototype.setSettings = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.UpdateSettingsRequest} returns this
 */
proto.eaconnect.UpdateSettingsRequest.prototype.clearSettings = function() {
  return this.setSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.UpdateSettingsRequest.prototype.hasSettings = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string applied_by_user = 4;
 * @return {string}
 */
proto.eaconnect.UpdateSettingsRequest.prototype.getAppliedByUser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UpdateSettingsRequest} returns this
 */
proto.eaconnect.UpdateSettingsRequest.prototype.setAppliedByUser = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string idempotency_key = 5;
 * @return {string}
 */
proto.eaconnect.UpdateSettingsRequest.prototype.getIdempotencyKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UpdateSettingsRequest} returns this
 */
proto.eaconnect.UpdateSettingsRequest.prototype.setIdempotencyKey = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 expected_desired_settings_version = 6;
 * @return {number}
 */
proto.eaconnect.UpdateSettingsRequest.prototype.getExpectedDesiredSettingsVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.UpdateSettingsRequest} returns this
 */
proto.eaconnect.UpdateSettingsRequest.prototype.setExpectedDesiredSettingsVersion = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.eaconnect.UpdateSettingsRequest} returns this
 */
proto.eaconnect.UpdateSettingsRequest.prototype.clearExpectedDesiredSettingsVersion = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.UpdateSettingsRequest.prototype.hasExpectedDesiredSettingsVersion = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.ListSettingsVersionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.ListSettingsVersionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.ListSettingsVersionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ListSettingsVersionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
instanceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
beforeVersion: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.ListSettingsVersionsRequest}
 */
proto.eaconnect.ListSettingsVersionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.ListSettingsVersionsRequest;
  return proto.eaconnect.ListSettingsVersionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.ListSettingsVersionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.ListSettingsVersionsRequest}
 */
proto.eaconnect.ListSettingsVersionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstanceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBeforeVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.ListSettingsVersionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.ListSettingsVersionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.ListSettingsVersionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ListSettingsVersionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstanceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getBeforeVersion();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string instance_id = 1;
 * @return {string}
 */
proto.eaconnect.ListSettingsVersionsRequest.prototype.getInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.ListSettingsVersionsRequest} returns this
 */
proto.eaconnect.ListSettingsVersionsRequest.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 page_size = 2;
 * @return {number}
 */
proto.eaconnect.ListSettingsVersionsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.ListSettingsVersionsRequest} returns this
 */
proto.eaconnect.ListSettingsVersionsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 before_version = 3;
 * @return {number}
 */
proto.eaconnect.ListSettingsVersionsRequest.prototype.getBeforeVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.ListSettingsVersionsRequest} returns this
 */
proto.eaconnect.ListSettingsVersionsRequest.prototype.setBeforeVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.eaconnect.ListSettingsVersionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.ListSettingsVersionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.ListSettingsVersionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.ListSettingsVersionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ListSettingsVersionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
versionsList: jspb.Message.toObjectList(msg.getVersionsList(),
    proto.eaconnect.SettingsVersion.toObject, includeInstance),
nextBeforeVersion: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.ListSettingsVersionsResponse}
 */
proto.eaconnect.ListSettingsVersionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.ListSettingsVersionsResponse;
  return proto.eaconnect.ListSettingsVersionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.ListSettingsVersionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.ListSettingsVersionsResponse}
 */
proto.eaconnect.ListSettingsVersionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.eaconnect.SettingsVersion;
      reader.readMessage(value,proto.eaconnect.SettingsVersion.deserializeBinaryFromReader);
      msg.addVersions(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNextBeforeVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.ListSettingsVersionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.ListSettingsVersionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.ListSettingsVersionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ListSettingsVersionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.eaconnect.SettingsVersion.serializeBinaryToWriter
    );
  }
  f = message.getNextBeforeVersion();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated SettingsVersion versions = 1;
 * @return {!Array<!proto.eaconnect.SettingsVersion>}
 */
proto.eaconnect.ListSettingsVersionsResponse.prototype.getVersionsList = function() {
  return /** @type{!Array<!proto.eaconnect.SettingsVersion>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.eaconnect.SettingsVersion, 1));
};


/**
 * @param {!Array<!proto.eaconnect.SettingsVersion>} value
 * @return {!proto.eaconnect.ListSettingsVersionsResponse} returns this
*/
proto.eaconnect.ListSettingsVersionsResponse.prototype.setVersionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.eaconnect.SettingsVersion=} opt_value
 * @param {number=} opt_index
 * @return {!proto.eaconnect.SettingsVersion}
 */
proto.eaconnect.ListSettingsVersionsResponse.prototype.addVersions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.eaconnect.SettingsVersion, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.eaconnect.ListSettingsVersionsResponse} returns this
 */
proto.eaconnect.ListSettingsVersionsResponse.prototype.clearVersionsList = function() {
  return this.setVersionsList([]);
};


/**
 * optional int32 next_before_version = 2;
 * @return {number}
 */
proto.eaconnect.ListSettingsVersionsResponse.prototype.getNextBeforeVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.ListSettingsVersionsResponse} returns this
 */
proto.eaconnect.ListSettingsVersionsResponse.prototype.setNextBeforeVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.RollbackSettingsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.RollbackSettingsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.RollbackSettingsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.RollbackSettingsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
instanceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
toVersion: jspb.Message.getFieldWithDefault(msg, 2, 0),
appliedByUser: jspb.Message.getFieldWithDefault(msg, 3, ""),
idempotencyKey: jspb.Message.getFieldWithDefault(msg, 4, ""),
expectedDesiredSettingsVersion: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.RollbackSettingsRequest}
 */
proto.eaconnect.RollbackSettingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.RollbackSettingsRequest;
  return proto.eaconnect.RollbackSettingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.RollbackSettingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.RollbackSettingsRequest}
 */
proto.eaconnect.RollbackSettingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstanceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setToVersion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppliedByUser(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdempotencyKey(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExpectedDesiredSettingsVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.RollbackSettingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.RollbackSettingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.RollbackSettingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.RollbackSettingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstanceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getToVersion();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAppliedByUser();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIdempotencyKey();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string instance_id = 1;
 * @return {string}
 */
proto.eaconnect.RollbackSettingsRequest.prototype.getInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.RollbackSettingsRequest} returns this
 */
proto.eaconnect.RollbackSettingsRequest.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 to_version = 2;
 * @return {number}
 */
proto.eaconnect.RollbackSettingsRequest.prototype.getToVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.RollbackSettingsRequest} returns this
 */
proto.eaconnect.RollbackSettingsRequest.prototype.setToVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string applied_by_user = 3;
 * @return {string}
 */
proto.eaconnect.RollbackSettingsRequest.prototype.getAppliedByUser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.RollbackSettingsRequest} returns this
 */
proto.eaconnect.RollbackSettingsRequest.prototype.setAppliedByUser = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string idempotency_key = 4;
 * @return {string}
 */
proto.eaconnect.RollbackSettingsRequest.prototype.getIdempotencyKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.RollbackSettingsRequest} returns this
 */
proto.eaconnect.RollbackSettingsRequest.prototype.setIdempotencyKey = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 expected_desired_settings_version = 5;
 * @return {number}
 */
proto.eaconnect.RollbackSettingsRequest.prototype.getExpectedDesiredSettingsVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.RollbackSettingsRequest} returns this
 */
proto.eaconnect.RollbackSettingsRequest.prototype.setExpectedDesiredSettingsVersion = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.eaconnect.RollbackSettingsRequest} returns this
 */
proto.eaconnect.RollbackSettingsRequest.prototype.clearExpectedDesiredSettingsVersion = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.RollbackSettingsRequest.prototype.hasExpectedDesiredSettingsVersion = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.BrokerProfile.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.BrokerProfile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.BrokerProfile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.BrokerProfile.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
displayName: jspb.Message.getFieldWithDefault(msg, 3, ""),
broker: jspb.Message.getFieldWithDefault(msg, 4, ""),
server: jspb.Message.getFieldWithDefault(msg, 5, ""),
accountLogin: jspb.Message.getFieldWithDefault(msg, 6, 0),
isDemo: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
platform: jspb.Message.getFieldWithDefault(msg, 9, ""),
hasServerRecord: jspb.Message.getBooleanFieldWithDefault(msg, 10, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.BrokerProfile}
 */
proto.eaconnect.BrokerProfile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.BrokerProfile;
  return proto.eaconnect.BrokerProfile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.BrokerProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.BrokerProfile}
 */
proto.eaconnect.BrokerProfile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setServer(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccountLogin(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDemo(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasServerRecord(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.BrokerProfile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.BrokerProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.BrokerProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.BrokerProfile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getServer();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAccountLogin();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getIsDemo();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getHasServerRecord();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.eaconnect.BrokerProfile.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.BrokerProfile} returns this
 */
proto.eaconnect.BrokerProfile.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.eaconnect.BrokerProfile.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.BrokerProfile} returns this
 */
proto.eaconnect.BrokerProfile.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string display_name = 3;
 * @return {string}
 */
proto.eaconnect.BrokerProfile.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.BrokerProfile} returns this
 */
proto.eaconnect.BrokerProfile.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string broker = 4;
 * @return {string}
 */
proto.eaconnect.BrokerProfile.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.BrokerProfile} returns this
 */
proto.eaconnect.BrokerProfile.prototype.setBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string server = 5;
 * @return {string}
 */
proto.eaconnect.BrokerProfile.prototype.getServer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.BrokerProfile} returns this
 */
proto.eaconnect.BrokerProfile.prototype.setServer = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 account_login = 6;
 * @return {number}
 */
proto.eaconnect.BrokerProfile.prototype.getAccountLogin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.BrokerProfile} returns this
 */
proto.eaconnect.BrokerProfile.prototype.setAccountLogin = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool is_demo = 7;
 * @return {boolean}
 */
proto.eaconnect.BrokerProfile.prototype.getIsDemo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.BrokerProfile} returns this
 */
proto.eaconnect.BrokerProfile.prototype.setIsDemo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.BrokerProfile.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.BrokerProfile} returns this
*/
proto.eaconnect.BrokerProfile.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.BrokerProfile} returns this
 */
proto.eaconnect.BrokerProfile.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.BrokerProfile.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string platform = 9;
 * @return {string}
 */
proto.eaconnect.BrokerProfile.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.BrokerProfile} returns this
 */
proto.eaconnect.BrokerProfile.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool has_server_record = 10;
 * @return {boolean}
 */
proto.eaconnect.BrokerProfile.prototype.getHasServerRecord = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.BrokerProfile} returns this
 */
proto.eaconnect.BrokerProfile.prototype.setHasServerRecord = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.CreateBrokerProfileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.CreateBrokerProfileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.CreateBrokerProfileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
broker: jspb.Message.getFieldWithDefault(msg, 3, ""),
server: jspb.Message.getFieldWithDefault(msg, 4, ""),
accountLogin: jspb.Message.getFieldWithDefault(msg, 5, 0),
password: jspb.Message.getFieldWithDefault(msg, 6, ""),
isDemo: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
platform: jspb.Message.getFieldWithDefault(msg, 8, ""),
serverRecord: msg.getServerRecord_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.CreateBrokerProfileRequest}
 */
proto.eaconnect.CreateBrokerProfileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.CreateBrokerProfileRequest;
  return proto.eaconnect.CreateBrokerProfileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.CreateBrokerProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.CreateBrokerProfileRequest}
 */
proto.eaconnect.CreateBrokerProfileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setServer(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccountLogin(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDemo(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 9:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setServerRecord(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.CreateBrokerProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.CreateBrokerProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.CreateBrokerProfileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getServer();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAccountLogin();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIsDemo();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getServerRecord_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      9,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CreateBrokerProfileRequest} returns this
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CreateBrokerProfileRequest} returns this
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string broker = 3;
 * @return {string}
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CreateBrokerProfileRequest} returns this
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.setBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string server = 4;
 * @return {string}
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.getServer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CreateBrokerProfileRequest} returns this
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.setServer = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 account_login = 5;
 * @return {number}
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.getAccountLogin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.CreateBrokerProfileRequest} returns this
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.setAccountLogin = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string password = 6;
 * @return {string}
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CreateBrokerProfileRequest} returns this
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool is_demo = 7;
 * @return {boolean}
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.getIsDemo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.CreateBrokerProfileRequest} returns this
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.setIsDemo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string platform = 8;
 * @return {string}
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CreateBrokerProfileRequest} returns this
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bytes server_record = 9;
 * @return {!(string|Uint8Array)}
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.getServerRecord = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * optional bytes server_record = 9;
 * This is a type-conversion wrapper around `getServerRecord()`
 * @return {string}
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.getServerRecord_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getServerRecord()));
};


/**
 * optional bytes server_record = 9;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getServerRecord()`
 * @return {!Uint8Array}
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.getServerRecord_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getServerRecord()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.eaconnect.CreateBrokerProfileRequest} returns this
 */
proto.eaconnect.CreateBrokerProfileRequest.prototype.setServerRecord = function(value) {
  return jspb.Message.setProto3BytesField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.ListBrokerProfilesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.ListBrokerProfilesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.ListBrokerProfilesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ListBrokerProfilesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
platform: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.ListBrokerProfilesRequest}
 */
proto.eaconnect.ListBrokerProfilesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.ListBrokerProfilesRequest;
  return proto.eaconnect.ListBrokerProfilesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.ListBrokerProfilesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.ListBrokerProfilesRequest}
 */
proto.eaconnect.ListBrokerProfilesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.ListBrokerProfilesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.ListBrokerProfilesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.ListBrokerProfilesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ListBrokerProfilesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.eaconnect.ListBrokerProfilesRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.ListBrokerProfilesRequest} returns this
 */
proto.eaconnect.ListBrokerProfilesRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string platform = 2;
 * @return {string}
 */
proto.eaconnect.ListBrokerProfilesRequest.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.ListBrokerProfilesRequest} returns this
 */
proto.eaconnect.ListBrokerProfilesRequest.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.eaconnect.ListBrokerProfilesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.ListBrokerProfilesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.ListBrokerProfilesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.ListBrokerProfilesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ListBrokerProfilesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
profilesList: jspb.Message.toObjectList(msg.getProfilesList(),
    proto.eaconnect.BrokerProfile.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.ListBrokerProfilesResponse}
 */
proto.eaconnect.ListBrokerProfilesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.ListBrokerProfilesResponse;
  return proto.eaconnect.ListBrokerProfilesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.ListBrokerProfilesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.ListBrokerProfilesResponse}
 */
proto.eaconnect.ListBrokerProfilesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.eaconnect.BrokerProfile;
      reader.readMessage(value,proto.eaconnect.BrokerProfile.deserializeBinaryFromReader);
      msg.addProfiles(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.ListBrokerProfilesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.ListBrokerProfilesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.ListBrokerProfilesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ListBrokerProfilesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProfilesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.eaconnect.BrokerProfile.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BrokerProfile profiles = 1;
 * @return {!Array<!proto.eaconnect.BrokerProfile>}
 */
proto.eaconnect.ListBrokerProfilesResponse.prototype.getProfilesList = function() {
  return /** @type{!Array<!proto.eaconnect.BrokerProfile>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.eaconnect.BrokerProfile, 1));
};


/**
 * @param {!Array<!proto.eaconnect.BrokerProfile>} value
 * @return {!proto.eaconnect.ListBrokerProfilesResponse} returns this
*/
proto.eaconnect.ListBrokerProfilesResponse.prototype.setProfilesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.eaconnect.BrokerProfile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.eaconnect.BrokerProfile}
 */
proto.eaconnect.ListBrokerProfilesResponse.prototype.addProfiles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.eaconnect.BrokerProfile, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.eaconnect.ListBrokerProfilesResponse} returns this
 */
proto.eaconnect.ListBrokerProfilesResponse.prototype.clearProfilesList = function() {
  return this.setProfilesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.CheckBrokerProfileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.CheckBrokerProfileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.CheckBrokerProfileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.CheckBrokerProfileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.CheckBrokerProfileRequest}
 */
proto.eaconnect.CheckBrokerProfileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.CheckBrokerProfileRequest;
  return proto.eaconnect.CheckBrokerProfileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.CheckBrokerProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.CheckBrokerProfileRequest}
 */
proto.eaconnect.CheckBrokerProfileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.CheckBrokerProfileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.CheckBrokerProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.CheckBrokerProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.CheckBrokerProfileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.eaconnect.CheckBrokerProfileRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CheckBrokerProfileRequest} returns this
 */
proto.eaconnect.CheckBrokerProfileRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.CheckBrokerProfileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.CheckBrokerProfileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.CheckBrokerProfileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.CheckBrokerProfileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
result: jspb.Message.getFieldWithDefault(msg, 1, ""),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.CheckBrokerProfileResponse}
 */
proto.eaconnect.CheckBrokerProfileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.CheckBrokerProfileResponse;
  return proto.eaconnect.CheckBrokerProfileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.CheckBrokerProfileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.CheckBrokerProfileResponse}
 */
proto.eaconnect.CheckBrokerProfileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setResult(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.CheckBrokerProfileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.CheckBrokerProfileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.CheckBrokerProfileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.CheckBrokerProfileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string result = 1;
 * @return {string}
 */
proto.eaconnect.CheckBrokerProfileResponse.prototype.getResult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CheckBrokerProfileResponse} returns this
 */
proto.eaconnect.CheckBrokerProfileResponse.prototype.setResult = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.eaconnect.CheckBrokerProfileResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.CheckBrokerProfileResponse} returns this
 */
proto.eaconnect.CheckBrokerProfileResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.ValidateBrokerLoginRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.ValidateBrokerLoginRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.ValidateBrokerLoginRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ValidateBrokerLoginRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
recheck: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.ValidateBrokerLoginRequest}
 */
proto.eaconnect.ValidateBrokerLoginRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.ValidateBrokerLoginRequest;
  return proto.eaconnect.ValidateBrokerLoginRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.ValidateBrokerLoginRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.ValidateBrokerLoginRequest}
 */
proto.eaconnect.ValidateBrokerLoginRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRecheck(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.ValidateBrokerLoginRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.ValidateBrokerLoginRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.ValidateBrokerLoginRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ValidateBrokerLoginRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRecheck();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.eaconnect.ValidateBrokerLoginRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.ValidateBrokerLoginRequest} returns this
 */
proto.eaconnect.ValidateBrokerLoginRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool recheck = 2;
 * @return {boolean}
 */
proto.eaconnect.ValidateBrokerLoginRequest.prototype.getRecheck = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.ValidateBrokerLoginRequest} returns this
 */
proto.eaconnect.ValidateBrokerLoginRequest.prototype.setRecheck = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.ValidateBrokerLoginResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.ValidateBrokerLoginResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.ValidateBrokerLoginResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ValidateBrokerLoginResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
result: jspb.Message.getFieldWithDefault(msg, 1, ""),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
checkedAt: (f = msg.getCheckedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
symbolsComplete: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
symbolsCollectedAt: (f = msg.getSymbolsCollectedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
nextCheckAt: (f = msg.getNextCheckAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
symbolCount: jspb.Message.getFieldWithDefault(msg, 8, 0),
symbolsVersion: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.ValidateBrokerLoginResponse}
 */
proto.eaconnect.ValidateBrokerLoginResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.ValidateBrokerLoginResponse;
  return proto.eaconnect.ValidateBrokerLoginResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.ValidateBrokerLoginResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.ValidateBrokerLoginResponse}
 */
proto.eaconnect.ValidateBrokerLoginResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setResult(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCheckedAt(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSymbolsComplete(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSymbolsCollectedAt(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setNextCheckAt(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSymbolCount(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolsVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.ValidateBrokerLoginResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.ValidateBrokerLoginResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.ValidateBrokerLoginResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ValidateBrokerLoginResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCheckedAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSymbolsComplete();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getSymbolsCollectedAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getNextCheckAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSymbolCount();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getSymbolsVersion();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string result = 1;
 * @return {string}
 */
proto.eaconnect.ValidateBrokerLoginResponse.prototype.getResult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.ValidateBrokerLoginResponse} returns this
 */
proto.eaconnect.ValidateBrokerLoginResponse.prototype.setResult = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.eaconnect.ValidateBrokerLoginResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.ValidateBrokerLoginResponse} returns this
 */
proto.eaconnect.ValidateBrokerLoginResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp checked_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.ValidateBrokerLoginResponse.prototype.getCheckedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.ValidateBrokerLoginResponse} returns this
*/
proto.eaconnect.ValidateBrokerLoginResponse.prototype.setCheckedAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.ValidateBrokerLoginResponse} returns this
 */
proto.eaconnect.ValidateBrokerLoginResponse.prototype.clearCheckedAt = function() {
  return this.setCheckedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.ValidateBrokerLoginResponse.prototype.hasCheckedAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool symbols_complete = 5;
 * @return {boolean}
 */
proto.eaconnect.ValidateBrokerLoginResponse.prototype.getSymbolsComplete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.ValidateBrokerLoginResponse} returns this
 */
proto.eaconnect.ValidateBrokerLoginResponse.prototype.setSymbolsComplete = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp symbols_collected_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.ValidateBrokerLoginResponse.prototype.getSymbolsCollectedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.ValidateBrokerLoginResponse} returns this
*/
proto.eaconnect.ValidateBrokerLoginResponse.prototype.setSymbolsCollectedAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.ValidateBrokerLoginResponse} returns this
 */
proto.eaconnect.ValidateBrokerLoginResponse.prototype.clearSymbolsCollectedAt = function() {
  return this.setSymbolsCollectedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.ValidateBrokerLoginResponse.prototype.hasSymbolsCollectedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp next_check_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.ValidateBrokerLoginResponse.prototype.getNextCheckAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.ValidateBrokerLoginResponse} returns this
*/
proto.eaconnect.ValidateBrokerLoginResponse.prototype.setNextCheckAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.ValidateBrokerLoginResponse} returns this
 */
proto.eaconnect.ValidateBrokerLoginResponse.prototype.clearNextCheckAt = function() {
  return this.setNextCheckAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.ValidateBrokerLoginResponse.prototype.hasNextCheckAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional uint32 symbol_count = 8;
 * @return {number}
 */
proto.eaconnect.ValidateBrokerLoginResponse.prototype.getSymbolCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.ValidateBrokerLoginResponse} returns this
 */
proto.eaconnect.ValidateBrokerLoginResponse.prototype.setSymbolCount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string symbols_version = 9;
 * @return {string}
 */
proto.eaconnect.ValidateBrokerLoginResponse.prototype.getSymbolsVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.ValidateBrokerLoginResponse} returns this
 */
proto.eaconnect.ValidateBrokerLoginResponse.prototype.setSymbolsVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.GetBrokerProfileSymbolsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.GetBrokerProfileSymbolsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.GetBrokerProfileSymbolsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetBrokerProfileSymbolsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.GetBrokerProfileSymbolsRequest}
 */
proto.eaconnect.GetBrokerProfileSymbolsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.GetBrokerProfileSymbolsRequest;
  return proto.eaconnect.GetBrokerProfileSymbolsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.GetBrokerProfileSymbolsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.GetBrokerProfileSymbolsRequest}
 */
proto.eaconnect.GetBrokerProfileSymbolsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.GetBrokerProfileSymbolsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.GetBrokerProfileSymbolsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.GetBrokerProfileSymbolsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetBrokerProfileSymbolsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.eaconnect.GetBrokerProfileSymbolsRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.GetBrokerProfileSymbolsRequest} returns this
 */
proto.eaconnect.GetBrokerProfileSymbolsRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.eaconnect.GetBrokerProfileSymbolsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.GetBrokerProfileSymbolsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.GetBrokerProfileSymbolsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.GetBrokerProfileSymbolsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetBrokerProfileSymbolsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
symbolsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
complete: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
collectedAt: (f = msg.getCollectedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
version: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.GetBrokerProfileSymbolsResponse}
 */
proto.eaconnect.GetBrokerProfileSymbolsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.GetBrokerProfileSymbolsResponse;
  return proto.eaconnect.GetBrokerProfileSymbolsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.GetBrokerProfileSymbolsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.GetBrokerProfileSymbolsResponse}
 */
proto.eaconnect.GetBrokerProfileSymbolsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addSymbols(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setComplete(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCollectedAt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.GetBrokerProfileSymbolsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.GetBrokerProfileSymbolsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.GetBrokerProfileSymbolsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetBrokerProfileSymbolsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbolsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getComplete();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getCollectedAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * repeated string symbols = 1;
 * @return {!Array<string>}
 */
proto.eaconnect.GetBrokerProfileSymbolsResponse.prototype.getSymbolsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.eaconnect.GetBrokerProfileSymbolsResponse} returns this
 */
proto.eaconnect.GetBrokerProfileSymbolsResponse.prototype.setSymbolsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.eaconnect.GetBrokerProfileSymbolsResponse} returns this
 */
proto.eaconnect.GetBrokerProfileSymbolsResponse.prototype.addSymbols = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.eaconnect.GetBrokerProfileSymbolsResponse} returns this
 */
proto.eaconnect.GetBrokerProfileSymbolsResponse.prototype.clearSymbolsList = function() {
  return this.setSymbolsList([]);
};


/**
 * optional bool complete = 2;
 * @return {boolean}
 */
proto.eaconnect.GetBrokerProfileSymbolsResponse.prototype.getComplete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.GetBrokerProfileSymbolsResponse} returns this
 */
proto.eaconnect.GetBrokerProfileSymbolsResponse.prototype.setComplete = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp collected_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.GetBrokerProfileSymbolsResponse.prototype.getCollectedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.GetBrokerProfileSymbolsResponse} returns this
*/
proto.eaconnect.GetBrokerProfileSymbolsResponse.prototype.setCollectedAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.GetBrokerProfileSymbolsResponse} returns this
 */
proto.eaconnect.GetBrokerProfileSymbolsResponse.prototype.clearCollectedAt = function() {
  return this.setCollectedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.GetBrokerProfileSymbolsResponse.prototype.hasCollectedAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string version = 4;
 * @return {string}
 */
proto.eaconnect.GetBrokerProfileSymbolsResponse.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.GetBrokerProfileSymbolsResponse} returns this
 */
proto.eaconnect.GetBrokerProfileSymbolsResponse.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.UpdateBrokerProfileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.UpdateBrokerProfileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.UpdateBrokerProfileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
password: jspb.Message.getFieldWithDefault(msg, 3, ""),
broker: jspb.Message.getFieldWithDefault(msg, 4, ""),
server: jspb.Message.getFieldWithDefault(msg, 5, ""),
accountLogin: jspb.Message.getFieldWithDefault(msg, 6, 0),
isDemo: (f = jspb.Message.getBooleanField(msg, 7)) == null ? undefined : f,
serverRecord: msg.getServerRecord_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.UpdateBrokerProfileRequest}
 */
proto.eaconnect.UpdateBrokerProfileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.UpdateBrokerProfileRequest;
  return proto.eaconnect.UpdateBrokerProfileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.UpdateBrokerProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.UpdateBrokerProfileRequest}
 */
proto.eaconnect.UpdateBrokerProfileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setServer(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccountLogin(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDemo(value);
      break;
    case 8:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setServerRecord(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.UpdateBrokerProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.UpdateBrokerProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.UpdateBrokerProfileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getServer();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAccountLogin();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getServerRecord_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      8,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UpdateBrokerProfileRequest} returns this
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UpdateBrokerProfileRequest} returns this
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string password = 3;
 * @return {string}
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UpdateBrokerProfileRequest} returns this
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string broker = 4;
 * @return {string}
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UpdateBrokerProfileRequest} returns this
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.setBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string server = 5;
 * @return {string}
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.getServer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UpdateBrokerProfileRequest} returns this
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.setServer = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 account_login = 6;
 * @return {number}
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.getAccountLogin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.UpdateBrokerProfileRequest} returns this
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.setAccountLogin = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool is_demo = 7;
 * @return {boolean}
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.getIsDemo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.UpdateBrokerProfileRequest} returns this
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.setIsDemo = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.eaconnect.UpdateBrokerProfileRequest} returns this
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.clearIsDemo = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.hasIsDemo = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bytes server_record = 8;
 * @return {!(string|Uint8Array)}
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.getServerRecord = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * optional bytes server_record = 8;
 * This is a type-conversion wrapper around `getServerRecord()`
 * @return {string}
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.getServerRecord_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getServerRecord()));
};


/**
 * optional bytes server_record = 8;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getServerRecord()`
 * @return {!Uint8Array}
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.getServerRecord_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getServerRecord()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.eaconnect.UpdateBrokerProfileRequest} returns this
 */
proto.eaconnect.UpdateBrokerProfileRequest.prototype.setServerRecord = function(value) {
  return jspb.Message.setProto3BytesField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.DeleteBrokerProfileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.DeleteBrokerProfileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.DeleteBrokerProfileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.DeleteBrokerProfileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.DeleteBrokerProfileRequest}
 */
proto.eaconnect.DeleteBrokerProfileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.DeleteBrokerProfileRequest;
  return proto.eaconnect.DeleteBrokerProfileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.DeleteBrokerProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.DeleteBrokerProfileRequest}
 */
proto.eaconnect.DeleteBrokerProfileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.DeleteBrokerProfileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.DeleteBrokerProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.DeleteBrokerProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.DeleteBrokerProfileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.eaconnect.DeleteBrokerProfileRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.DeleteBrokerProfileRequest} returns this
 */
proto.eaconnect.DeleteBrokerProfileRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.eaconnect.InstanceStatus.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.InstanceStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.InstanceStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.InstanceStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.InstanceStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
instanceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
status: jspb.Message.getFieldWithDefault(msg, 2, ""),
settingsVersion: jspb.Message.getFieldWithDefault(msg, 3, 0),
assignedPod: jspb.Message.getFieldWithDefault(msg, 4, ""),
assignedSlot: jspb.Message.getFieldWithDefault(msg, 5, 0),
recentEventsList: jspb.Message.toObjectList(msg.getRecentEventsList(),
    proto.eaconnect.InstanceEvent.toObject, includeInstance),
autoRestartStatus: (f = msg.getAutoRestartStatus()) && proto.eaconnect.InstanceAutoRestartStatus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.InstanceStatus}
 */
proto.eaconnect.InstanceStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.InstanceStatus;
  return proto.eaconnect.InstanceStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.InstanceStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.InstanceStatus}
 */
proto.eaconnect.InstanceStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstanceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSettingsVersion(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignedPod(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAssignedSlot(value);
      break;
    case 6:
      var value = new proto.eaconnect.InstanceEvent;
      reader.readMessage(value,proto.eaconnect.InstanceEvent.deserializeBinaryFromReader);
      msg.addRecentEvents(value);
      break;
    case 8:
      var value = new proto.eaconnect.InstanceAutoRestartStatus;
      reader.readMessage(value,proto.eaconnect.InstanceAutoRestartStatus.deserializeBinaryFromReader);
      msg.setAutoRestartStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.InstanceStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.InstanceStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.InstanceStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.InstanceStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstanceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSettingsVersion();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getAssignedPod();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAssignedSlot();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getRecentEventsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.eaconnect.InstanceEvent.serializeBinaryToWriter
    );
  }
  f = message.getAutoRestartStatus();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.eaconnect.InstanceAutoRestartStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional string instance_id = 1;
 * @return {string}
 */
proto.eaconnect.InstanceStatus.prototype.getInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.InstanceStatus} returns this
 */
proto.eaconnect.InstanceStatus.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.eaconnect.InstanceStatus.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.InstanceStatus} returns this
 */
proto.eaconnect.InstanceStatus.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 settings_version = 3;
 * @return {number}
 */
proto.eaconnect.InstanceStatus.prototype.getSettingsVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceStatus} returns this
 */
proto.eaconnect.InstanceStatus.prototype.setSettingsVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string assigned_pod = 4;
 * @return {string}
 */
proto.eaconnect.InstanceStatus.prototype.getAssignedPod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.InstanceStatus} returns this
 */
proto.eaconnect.InstanceStatus.prototype.setAssignedPod = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 assigned_slot = 5;
 * @return {number}
 */
proto.eaconnect.InstanceStatus.prototype.getAssignedSlot = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceStatus} returns this
 */
proto.eaconnect.InstanceStatus.prototype.setAssignedSlot = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * repeated InstanceEvent recent_events = 6;
 * @return {!Array<!proto.eaconnect.InstanceEvent>}
 */
proto.eaconnect.InstanceStatus.prototype.getRecentEventsList = function() {
  return /** @type{!Array<!proto.eaconnect.InstanceEvent>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.eaconnect.InstanceEvent, 6));
};


/**
 * @param {!Array<!proto.eaconnect.InstanceEvent>} value
 * @return {!proto.eaconnect.InstanceStatus} returns this
*/
proto.eaconnect.InstanceStatus.prototype.setRecentEventsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.eaconnect.InstanceEvent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.eaconnect.InstanceEvent}
 */
proto.eaconnect.InstanceStatus.prototype.addRecentEvents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.eaconnect.InstanceEvent, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.eaconnect.InstanceStatus} returns this
 */
proto.eaconnect.InstanceStatus.prototype.clearRecentEventsList = function() {
  return this.setRecentEventsList([]);
};


/**
 * optional InstanceAutoRestartStatus auto_restart_status = 8;
 * @return {?proto.eaconnect.InstanceAutoRestartStatus}
 */
proto.eaconnect.InstanceStatus.prototype.getAutoRestartStatus = function() {
  return /** @type{?proto.eaconnect.InstanceAutoRestartStatus} */ (
    jspb.Message.getWrapperField(this, proto.eaconnect.InstanceAutoRestartStatus, 8));
};


/**
 * @param {?proto.eaconnect.InstanceAutoRestartStatus|undefined} value
 * @return {!proto.eaconnect.InstanceStatus} returns this
*/
proto.eaconnect.InstanceStatus.prototype.setAutoRestartStatus = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.InstanceStatus} returns this
 */
proto.eaconnect.InstanceStatus.prototype.clearAutoRestartStatus = function() {
  return this.setAutoRestartStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.InstanceStatus.prototype.hasAutoRestartStatus = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.InstanceAutoRestartStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.InstanceAutoRestartStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.InstanceAutoRestartStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.InstanceAutoRestartStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
attemptsInCurrentWindow: jspb.Message.getFieldWithDefault(msg, 1, 0),
nextAttemptAt: (f = msg.getNextAttemptAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
lastFailureCode: jspb.Message.getFieldWithDefault(msg, 3, ""),
budgetExhausted: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.InstanceAutoRestartStatus}
 */
proto.eaconnect.InstanceAutoRestartStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.InstanceAutoRestartStatus;
  return proto.eaconnect.InstanceAutoRestartStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.InstanceAutoRestartStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.InstanceAutoRestartStatus}
 */
proto.eaconnect.InstanceAutoRestartStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAttemptsInCurrentWindow(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setNextAttemptAt(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastFailureCode(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBudgetExhausted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.InstanceAutoRestartStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.InstanceAutoRestartStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.InstanceAutoRestartStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.InstanceAutoRestartStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttemptsInCurrentWindow();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getNextAttemptAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLastFailureCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBudgetExhausted();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional uint32 attempts_in_current_window = 1;
 * @return {number}
 */
proto.eaconnect.InstanceAutoRestartStatus.prototype.getAttemptsInCurrentWindow = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceAutoRestartStatus} returns this
 */
proto.eaconnect.InstanceAutoRestartStatus.prototype.setAttemptsInCurrentWindow = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp next_attempt_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.InstanceAutoRestartStatus.prototype.getNextAttemptAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.InstanceAutoRestartStatus} returns this
*/
proto.eaconnect.InstanceAutoRestartStatus.prototype.setNextAttemptAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.InstanceAutoRestartStatus} returns this
 */
proto.eaconnect.InstanceAutoRestartStatus.prototype.clearNextAttemptAt = function() {
  return this.setNextAttemptAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.InstanceAutoRestartStatus.prototype.hasNextAttemptAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string last_failure_code = 3;
 * @return {string}
 */
proto.eaconnect.InstanceAutoRestartStatus.prototype.getLastFailureCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.InstanceAutoRestartStatus} returns this
 */
proto.eaconnect.InstanceAutoRestartStatus.prototype.setLastFailureCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool budget_exhausted = 4;
 * @return {boolean}
 */
proto.eaconnect.InstanceAutoRestartStatus.prototype.getBudgetExhausted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.InstanceAutoRestartStatus} returns this
 */
proto.eaconnect.InstanceAutoRestartStatus.prototype.setBudgetExhausted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.InstanceEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.InstanceEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.InstanceEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.InstanceEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
instanceId: jspb.Message.getFieldWithDefault(msg, 2, ""),
ts: (f = msg.getTs()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
level: jspb.Message.getFieldWithDefault(msg, 4, ""),
eventType: jspb.Message.getFieldWithDefault(msg, 5, ""),
message: jspb.Message.getFieldWithDefault(msg, 6, ""),
source: jspb.Message.getFieldWithDefault(msg, 7, ""),
payloadJson: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.InstanceEvent}
 */
proto.eaconnect.InstanceEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.InstanceEvent;
  return proto.eaconnect.InstanceEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.InstanceEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.InstanceEvent}
 */
proto.eaconnect.InstanceEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstanceId(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTs(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLevel(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPayloadJson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.InstanceEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.InstanceEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.InstanceEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.InstanceEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getInstanceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTs();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLevel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEventType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPayloadJson();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.eaconnect.InstanceEvent.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceEvent} returns this
 */
proto.eaconnect.InstanceEvent.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string instance_id = 2;
 * @return {string}
 */
proto.eaconnect.InstanceEvent.prototype.getInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.InstanceEvent} returns this
 */
proto.eaconnect.InstanceEvent.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp ts = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.InstanceEvent.prototype.getTs = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.InstanceEvent} returns this
*/
proto.eaconnect.InstanceEvent.prototype.setTs = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.InstanceEvent} returns this
 */
proto.eaconnect.InstanceEvent.prototype.clearTs = function() {
  return this.setTs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.InstanceEvent.prototype.hasTs = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string level = 4;
 * @return {string}
 */
proto.eaconnect.InstanceEvent.prototype.getLevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.InstanceEvent} returns this
 */
proto.eaconnect.InstanceEvent.prototype.setLevel = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string event_type = 5;
 * @return {string}
 */
proto.eaconnect.InstanceEvent.prototype.getEventType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.InstanceEvent} returns this
 */
proto.eaconnect.InstanceEvent.prototype.setEventType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string message = 6;
 * @return {string}
 */
proto.eaconnect.InstanceEvent.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.InstanceEvent} returns this
 */
proto.eaconnect.InstanceEvent.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string source = 7;
 * @return {string}
 */
proto.eaconnect.InstanceEvent.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.InstanceEvent} returns this
 */
proto.eaconnect.InstanceEvent.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string payload_json = 8;
 * @return {string}
 */
proto.eaconnect.InstanceEvent.prototype.getPayloadJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.InstanceEvent} returns this
 */
proto.eaconnect.InstanceEvent.prototype.setPayloadJson = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.GetInstanceStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.GetInstanceStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.GetInstanceStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetInstanceStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
instanceId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.GetInstanceStatusRequest}
 */
proto.eaconnect.GetInstanceStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.GetInstanceStatusRequest;
  return proto.eaconnect.GetInstanceStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.GetInstanceStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.GetInstanceStatusRequest}
 */
proto.eaconnect.GetInstanceStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstanceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.GetInstanceStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.GetInstanceStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.GetInstanceStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetInstanceStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstanceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string instance_id = 1;
 * @return {string}
 */
proto.eaconnect.GetInstanceStatusRequest.prototype.getInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.GetInstanceStatusRequest} returns this
 */
proto.eaconnect.GetInstanceStatusRequest.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.GetInstanceMetricsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.GetInstanceMetricsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.GetInstanceMetricsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetInstanceMetricsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
instanceId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.GetInstanceMetricsRequest}
 */
proto.eaconnect.GetInstanceMetricsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.GetInstanceMetricsRequest;
  return proto.eaconnect.GetInstanceMetricsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.GetInstanceMetricsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.GetInstanceMetricsRequest}
 */
proto.eaconnect.GetInstanceMetricsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstanceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.GetInstanceMetricsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.GetInstanceMetricsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.GetInstanceMetricsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetInstanceMetricsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstanceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string instance_id = 1;
 * @return {string}
 */
proto.eaconnect.GetInstanceMetricsRequest.prototype.getInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.GetInstanceMetricsRequest} returns this
 */
proto.eaconnect.GetInstanceMetricsRequest.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.InstanceMetrics.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.InstanceMetrics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.InstanceMetrics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.InstanceMetrics.toObject = function(includeInstance, msg) {
  var f, obj = {
instanceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
balance: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
equity: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
profit: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
margin: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
marginFree: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
positions: jspb.Message.getFieldWithDefault(msg, 7, 0),
currency: jspb.Message.getFieldWithDefault(msg, 8, ""),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
memoryCurrentMib: jspb.Message.getFieldWithDefault(msg, 10, 0),
memoryPeakMib: jspb.Message.getFieldWithDefault(msg, 11, 0),
cpuMilli: jspb.Message.getFieldWithDefault(msg, 12, 0),
oomKills: jspb.Message.getFieldWithDefault(msg, 13, 0),
memoryLimitMib: jspb.Message.getFieldWithDefault(msg, 14, 0),
memoryBudgetMib: jspb.Message.getFieldWithDefault(msg, 15, 0),
throttleEvents: jspb.Message.getFieldWithDefault(msg, 16, 0),
resourceState: jspb.Message.getFieldWithDefault(msg, 17, ""),
tradingUpdatedAt: (f = msg.getTradingUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
hostUpdatedAt: (f = msg.getHostUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
credit: jspb.Message.getFloatingPointFieldWithDefault(msg, 20, 0.0),
accountLogin: jspb.Message.getFieldWithDefault(msg, 21, 0),
brokerConnected: jspb.Message.getBooleanFieldWithDefault(msg, 22, false),
terminalTradeAllowed: jspb.Message.getBooleanFieldWithDefault(msg, 23, false),
accountTradeAllowed: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
accountExpertAllowed: jspb.Message.getBooleanFieldWithDefault(msg, 25, false),
accountTradeMode: jspb.Message.getFieldWithDefault(msg, 26, 0),
symbol: jspb.Message.getFieldWithDefault(msg, 27, ""),
symbolSynchronized: jspb.Message.getBooleanFieldWithDefault(msg, 28, false),
symbolTradeMode: jspb.Message.getFieldWithDefault(msg, 29, 0),
sessionKnown: jspb.Message.getBooleanFieldWithDefault(msg, 30, false),
sessionOpen: jspb.Message.getBooleanFieldWithDefault(msg, 31, false),
lastTickTimeMsc: jspb.Message.getFieldWithDefault(msg, 32, 0),
tradingCondition: jspb.Message.getFieldWithDefault(msg, 34, ""),
tradingStateUpdatedAt: (f = msg.getTradingStateUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.InstanceMetrics}
 */
proto.eaconnect.InstanceMetrics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.InstanceMetrics;
  return proto.eaconnect.InstanceMetrics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.InstanceMetrics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.InstanceMetrics}
 */
proto.eaconnect.InstanceMetrics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstanceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBalance(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEquity(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProfit(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMargin(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMarginFree(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPositions(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMemoryCurrentMib(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMemoryPeakMib(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCpuMilli(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOomKills(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMemoryLimitMib(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMemoryBudgetMib(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setThrottleEvents(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setResourceState(value);
      break;
    case 18:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTradingUpdatedAt(value);
      break;
    case 19:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setHostUpdatedAt(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCredit(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccountLogin(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBrokerConnected(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTerminalTradeAllowed(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAccountTradeAllowed(value);
      break;
    case 25:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAccountExpertAllowed(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAccountTradeMode(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 28:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSymbolSynchronized(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSymbolTradeMode(value);
      break;
    case 30:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSessionKnown(value);
      break;
    case 31:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSessionOpen(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastTickTimeMsc(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradingCondition(value);
      break;
    case 35:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTradingStateUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.InstanceMetrics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.InstanceMetrics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.InstanceMetrics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.InstanceMetrics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstanceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBalance();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getEquity();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getProfit();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getMargin();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getMarginFree();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getPositions();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMemoryCurrentMib();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getMemoryPeakMib();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getCpuMilli();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getOomKills();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getMemoryLimitMib();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getMemoryBudgetMib();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getThrottleEvents();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getResourceState();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getTradingUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getHostUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCredit();
  if (f !== 0.0) {
    writer.writeDouble(
      20,
      f
    );
  }
  f = message.getAccountLogin();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getBrokerConnected();
  if (f) {
    writer.writeBool(
      22,
      f
    );
  }
  f = message.getTerminalTradeAllowed();
  if (f) {
    writer.writeBool(
      23,
      f
    );
  }
  f = message.getAccountTradeAllowed();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getAccountExpertAllowed();
  if (f) {
    writer.writeBool(
      25,
      f
    );
  }
  f = message.getAccountTradeMode();
  if (f !== 0) {
    writer.writeInt32(
      26,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getSymbolSynchronized();
  if (f) {
    writer.writeBool(
      28,
      f
    );
  }
  f = message.getSymbolTradeMode();
  if (f !== 0) {
    writer.writeInt32(
      29,
      f
    );
  }
  f = message.getSessionKnown();
  if (f) {
    writer.writeBool(
      30,
      f
    );
  }
  f = message.getSessionOpen();
  if (f) {
    writer.writeBool(
      31,
      f
    );
  }
  f = message.getLastTickTimeMsc();
  if (f !== 0) {
    writer.writeInt64(
      32,
      f
    );
  }
  f = message.getTradingCondition();
  if (f.length > 0) {
    writer.writeString(
      34,
      f
    );
  }
  f = message.getTradingStateUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      35,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string instance_id = 1;
 * @return {string}
 */
proto.eaconnect.InstanceMetrics.prototype.getInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double balance = 2;
 * @return {number}
 */
proto.eaconnect.InstanceMetrics.prototype.getBalance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setBalance = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double equity = 3;
 * @return {number}
 */
proto.eaconnect.InstanceMetrics.prototype.getEquity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setEquity = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double profit = 4;
 * @return {number}
 */
proto.eaconnect.InstanceMetrics.prototype.getProfit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setProfit = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double margin = 5;
 * @return {number}
 */
proto.eaconnect.InstanceMetrics.prototype.getMargin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setMargin = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double margin_free = 6;
 * @return {number}
 */
proto.eaconnect.InstanceMetrics.prototype.getMarginFree = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setMarginFree = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional int32 positions = 7;
 * @return {number}
 */
proto.eaconnect.InstanceMetrics.prototype.getPositions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setPositions = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string currency = 8;
 * @return {string}
 */
proto.eaconnect.InstanceMetrics.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp updated_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.InstanceMetrics.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
*/
proto.eaconnect.InstanceMetrics.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.InstanceMetrics.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional int64 memory_current_mib = 10;
 * @return {number}
 */
proto.eaconnect.InstanceMetrics.prototype.getMemoryCurrentMib = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setMemoryCurrentMib = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 memory_peak_mib = 11;
 * @return {number}
 */
proto.eaconnect.InstanceMetrics.prototype.getMemoryPeakMib = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setMemoryPeakMib = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 cpu_milli = 12;
 * @return {number}
 */
proto.eaconnect.InstanceMetrics.prototype.getCpuMilli = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setCpuMilli = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 oom_kills = 13;
 * @return {number}
 */
proto.eaconnect.InstanceMetrics.prototype.getOomKills = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setOomKills = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 memory_limit_mib = 14;
 * @return {number}
 */
proto.eaconnect.InstanceMetrics.prototype.getMemoryLimitMib = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setMemoryLimitMib = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 memory_budget_mib = 15;
 * @return {number}
 */
proto.eaconnect.InstanceMetrics.prototype.getMemoryBudgetMib = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setMemoryBudgetMib = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int64 throttle_events = 16;
 * @return {number}
 */
proto.eaconnect.InstanceMetrics.prototype.getThrottleEvents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setThrottleEvents = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional string resource_state = 17;
 * @return {string}
 */
proto.eaconnect.InstanceMetrics.prototype.getResourceState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setResourceState = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional google.protobuf.Timestamp trading_updated_at = 18;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.InstanceMetrics.prototype.getTradingUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 18));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
*/
proto.eaconnect.InstanceMetrics.prototype.setTradingUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.clearTradingUpdatedAt = function() {
  return this.setTradingUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.InstanceMetrics.prototype.hasTradingUpdatedAt = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional google.protobuf.Timestamp host_updated_at = 19;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.InstanceMetrics.prototype.getHostUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 19));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
*/
proto.eaconnect.InstanceMetrics.prototype.setHostUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.clearHostUpdatedAt = function() {
  return this.setHostUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.InstanceMetrics.prototype.hasHostUpdatedAt = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional double credit = 20;
 * @return {number}
 */
proto.eaconnect.InstanceMetrics.prototype.getCredit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setCredit = function(value) {
  return jspb.Message.setProto3FloatField(this, 20, value);
};


/**
 * optional int64 account_login = 21;
 * @return {number}
 */
proto.eaconnect.InstanceMetrics.prototype.getAccountLogin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setAccountLogin = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional bool broker_connected = 22;
 * @return {boolean}
 */
proto.eaconnect.InstanceMetrics.prototype.getBrokerConnected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setBrokerConnected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 22, value);
};


/**
 * optional bool terminal_trade_allowed = 23;
 * @return {boolean}
 */
proto.eaconnect.InstanceMetrics.prototype.getTerminalTradeAllowed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setTerminalTradeAllowed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 23, value);
};


/**
 * optional bool account_trade_allowed = 24;
 * @return {boolean}
 */
proto.eaconnect.InstanceMetrics.prototype.getAccountTradeAllowed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setAccountTradeAllowed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional bool account_expert_allowed = 25;
 * @return {boolean}
 */
proto.eaconnect.InstanceMetrics.prototype.getAccountExpertAllowed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 25, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setAccountExpertAllowed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 25, value);
};


/**
 * optional int32 account_trade_mode = 26;
 * @return {number}
 */
proto.eaconnect.InstanceMetrics.prototype.getAccountTradeMode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setAccountTradeMode = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional string symbol = 27;
 * @return {string}
 */
proto.eaconnect.InstanceMetrics.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional bool symbol_synchronized = 28;
 * @return {boolean}
 */
proto.eaconnect.InstanceMetrics.prototype.getSymbolSynchronized = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 28, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setSymbolSynchronized = function(value) {
  return jspb.Message.setProto3BooleanField(this, 28, value);
};


/**
 * optional int32 symbol_trade_mode = 29;
 * @return {number}
 */
proto.eaconnect.InstanceMetrics.prototype.getSymbolTradeMode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setSymbolTradeMode = function(value) {
  return jspb.Message.setProto3IntField(this, 29, value);
};


/**
 * optional bool session_known = 30;
 * @return {boolean}
 */
proto.eaconnect.InstanceMetrics.prototype.getSessionKnown = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 30, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setSessionKnown = function(value) {
  return jspb.Message.setProto3BooleanField(this, 30, value);
};


/**
 * optional bool session_open = 31;
 * @return {boolean}
 */
proto.eaconnect.InstanceMetrics.prototype.getSessionOpen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 31, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setSessionOpen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 31, value);
};


/**
 * optional int64 last_tick_time_msc = 32;
 * @return {number}
 */
proto.eaconnect.InstanceMetrics.prototype.getLastTickTimeMsc = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 32, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setLastTickTimeMsc = function(value) {
  return jspb.Message.setProto3IntField(this, 32, value);
};


/**
 * optional string trading_condition = 34;
 * @return {string}
 */
proto.eaconnect.InstanceMetrics.prototype.getTradingCondition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.setTradingCondition = function(value) {
  return jspb.Message.setProto3StringField(this, 34, value);
};


/**
 * optional google.protobuf.Timestamp trading_state_updated_at = 35;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.InstanceMetrics.prototype.getTradingStateUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 35));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.InstanceMetrics} returns this
*/
proto.eaconnect.InstanceMetrics.prototype.setTradingStateUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 35, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.InstanceMetrics} returns this
 */
proto.eaconnect.InstanceMetrics.prototype.clearTradingStateUpdatedAt = function() {
  return this.setTradingStateUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.InstanceMetrics.prototype.hasTradingStateUpdatedAt = function() {
  return jspb.Message.getField(this, 35) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.ListEquityHistoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.ListEquityHistoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.ListEquityHistoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ListEquityHistoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
instanceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
hours: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.ListEquityHistoryRequest}
 */
proto.eaconnect.ListEquityHistoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.ListEquityHistoryRequest;
  return proto.eaconnect.ListEquityHistoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.ListEquityHistoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.ListEquityHistoryRequest}
 */
proto.eaconnect.ListEquityHistoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstanceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHours(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.ListEquityHistoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.ListEquityHistoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.ListEquityHistoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ListEquityHistoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstanceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHours();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string instance_id = 1;
 * @return {string}
 */
proto.eaconnect.ListEquityHistoryRequest.prototype.getInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.ListEquityHistoryRequest} returns this
 */
proto.eaconnect.ListEquityHistoryRequest.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 hours = 2;
 * @return {number}
 */
proto.eaconnect.ListEquityHistoryRequest.prototype.getHours = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.ListEquityHistoryRequest} returns this
 */
proto.eaconnect.ListEquityHistoryRequest.prototype.setHours = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.EquitySample.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.EquitySample.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.EquitySample} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.EquitySample.toObject = function(includeInstance, msg) {
  var f, obj = {
ts: (f = msg.getTs()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
balance: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
equity: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
profit: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.EquitySample}
 */
proto.eaconnect.EquitySample.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.EquitySample;
  return proto.eaconnect.EquitySample.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.EquitySample} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.EquitySample}
 */
proto.eaconnect.EquitySample.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTs(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBalance(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEquity(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProfit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.EquitySample.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.EquitySample.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.EquitySample} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.EquitySample.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTs();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getBalance();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getEquity();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getProfit();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp ts = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.EquitySample.prototype.getTs = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.EquitySample} returns this
*/
proto.eaconnect.EquitySample.prototype.setTs = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.EquitySample} returns this
 */
proto.eaconnect.EquitySample.prototype.clearTs = function() {
  return this.setTs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.EquitySample.prototype.hasTs = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional double balance = 2;
 * @return {number}
 */
proto.eaconnect.EquitySample.prototype.getBalance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.EquitySample} returns this
 */
proto.eaconnect.EquitySample.prototype.setBalance = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double equity = 3;
 * @return {number}
 */
proto.eaconnect.EquitySample.prototype.getEquity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.EquitySample} returns this
 */
proto.eaconnect.EquitySample.prototype.setEquity = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double profit = 4;
 * @return {number}
 */
proto.eaconnect.EquitySample.prototype.getProfit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.EquitySample} returns this
 */
proto.eaconnect.EquitySample.prototype.setProfit = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.eaconnect.ListEquityHistoryResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.ListEquityHistoryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.ListEquityHistoryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.ListEquityHistoryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ListEquityHistoryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
samplesList: jspb.Message.toObjectList(msg.getSamplesList(),
    proto.eaconnect.EquitySample.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.ListEquityHistoryResponse}
 */
proto.eaconnect.ListEquityHistoryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.ListEquityHistoryResponse;
  return proto.eaconnect.ListEquityHistoryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.ListEquityHistoryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.ListEquityHistoryResponse}
 */
proto.eaconnect.ListEquityHistoryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.eaconnect.EquitySample;
      reader.readMessage(value,proto.eaconnect.EquitySample.deserializeBinaryFromReader);
      msg.addSamples(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.ListEquityHistoryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.ListEquityHistoryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.ListEquityHistoryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ListEquityHistoryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSamplesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.eaconnect.EquitySample.serializeBinaryToWriter
    );
  }
};


/**
 * repeated EquitySample samples = 1;
 * @return {!Array<!proto.eaconnect.EquitySample>}
 */
proto.eaconnect.ListEquityHistoryResponse.prototype.getSamplesList = function() {
  return /** @type{!Array<!proto.eaconnect.EquitySample>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.eaconnect.EquitySample, 1));
};


/**
 * @param {!Array<!proto.eaconnect.EquitySample>} value
 * @return {!proto.eaconnect.ListEquityHistoryResponse} returns this
*/
proto.eaconnect.ListEquityHistoryResponse.prototype.setSamplesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.eaconnect.EquitySample=} opt_value
 * @param {number=} opt_index
 * @return {!proto.eaconnect.EquitySample}
 */
proto.eaconnect.ListEquityHistoryResponse.prototype.addSamples = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.eaconnect.EquitySample, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.eaconnect.ListEquityHistoryResponse} returns this
 */
proto.eaconnect.ListEquityHistoryResponse.prototype.clearSamplesList = function() {
  return this.setSamplesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.GetInstanceJournalRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.GetInstanceJournalRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.GetInstanceJournalRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetInstanceJournalRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
instanceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
tailLines: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.GetInstanceJournalRequest}
 */
proto.eaconnect.GetInstanceJournalRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.GetInstanceJournalRequest;
  return proto.eaconnect.GetInstanceJournalRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.GetInstanceJournalRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.GetInstanceJournalRequest}
 */
proto.eaconnect.GetInstanceJournalRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstanceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTailLines(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.GetInstanceJournalRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.GetInstanceJournalRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.GetInstanceJournalRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetInstanceJournalRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstanceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTailLines();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string instance_id = 1;
 * @return {string}
 */
proto.eaconnect.GetInstanceJournalRequest.prototype.getInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.GetInstanceJournalRequest} returns this
 */
proto.eaconnect.GetInstanceJournalRequest.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 tail_lines = 2;
 * @return {number}
 */
proto.eaconnect.GetInstanceJournalRequest.prototype.getTailLines = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.GetInstanceJournalRequest} returns this
 */
proto.eaconnect.GetInstanceJournalRequest.prototype.setTailLines = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.JournalLine.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.JournalLine.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.JournalLine} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.JournalLine.toObject = function(includeInstance, msg) {
  var f, obj = {
ts: (f = msg.getTs()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
source: jspb.Message.getFieldWithDefault(msg, 2, ""),
line: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.JournalLine}
 */
proto.eaconnect.JournalLine.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.JournalLine;
  return proto.eaconnect.JournalLine.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.JournalLine} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.JournalLine}
 */
proto.eaconnect.JournalLine.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTs(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLine(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.JournalLine.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.JournalLine.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.JournalLine} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.JournalLine.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTs();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLine();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp ts = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.JournalLine.prototype.getTs = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.JournalLine} returns this
*/
proto.eaconnect.JournalLine.prototype.setTs = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.JournalLine} returns this
 */
proto.eaconnect.JournalLine.prototype.clearTs = function() {
  return this.setTs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.JournalLine.prototype.hasTs = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string source = 2;
 * @return {string}
 */
proto.eaconnect.JournalLine.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.JournalLine} returns this
 */
proto.eaconnect.JournalLine.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string line = 3;
 * @return {string}
 */
proto.eaconnect.JournalLine.prototype.getLine = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.JournalLine} returns this
 */
proto.eaconnect.JournalLine.prototype.setLine = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.eaconnect.GetInstanceJournalResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.GetInstanceJournalResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.GetInstanceJournalResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.GetInstanceJournalResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetInstanceJournalResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
linesList: jspb.Message.toObjectList(msg.getLinesList(),
    proto.eaconnect.JournalLine.toObject, includeInstance),
note: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.GetInstanceJournalResponse}
 */
proto.eaconnect.GetInstanceJournalResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.GetInstanceJournalResponse;
  return proto.eaconnect.GetInstanceJournalResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.GetInstanceJournalResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.GetInstanceJournalResponse}
 */
proto.eaconnect.GetInstanceJournalResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.eaconnect.JournalLine;
      reader.readMessage(value,proto.eaconnect.JournalLine.deserializeBinaryFromReader);
      msg.addLines(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNote(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.GetInstanceJournalResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.GetInstanceJournalResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.GetInstanceJournalResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetInstanceJournalResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLinesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.eaconnect.JournalLine.serializeBinaryToWriter
    );
  }
  f = message.getNote();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated JournalLine lines = 1;
 * @return {!Array<!proto.eaconnect.JournalLine>}
 */
proto.eaconnect.GetInstanceJournalResponse.prototype.getLinesList = function() {
  return /** @type{!Array<!proto.eaconnect.JournalLine>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.eaconnect.JournalLine, 1));
};


/**
 * @param {!Array<!proto.eaconnect.JournalLine>} value
 * @return {!proto.eaconnect.GetInstanceJournalResponse} returns this
*/
proto.eaconnect.GetInstanceJournalResponse.prototype.setLinesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.eaconnect.JournalLine=} opt_value
 * @param {number=} opt_index
 * @return {!proto.eaconnect.JournalLine}
 */
proto.eaconnect.GetInstanceJournalResponse.prototype.addLines = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.eaconnect.JournalLine, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.eaconnect.GetInstanceJournalResponse} returns this
 */
proto.eaconnect.GetInstanceJournalResponse.prototype.clearLinesList = function() {
  return this.setLinesList([]);
};


/**
 * optional string note = 2;
 * @return {string}
 */
proto.eaconnect.GetInstanceJournalResponse.prototype.getNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.GetInstanceJournalResponse} returns this
 */
proto.eaconnect.GetInstanceJournalResponse.prototype.setNote = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.GetHostingOverviewRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.GetHostingOverviewRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.GetHostingOverviewRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetHostingOverviewRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.GetHostingOverviewRequest}
 */
proto.eaconnect.GetHostingOverviewRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.GetHostingOverviewRequest;
  return proto.eaconnect.GetHostingOverviewRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.GetHostingOverviewRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.GetHostingOverviewRequest}
 */
proto.eaconnect.GetHostingOverviewRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.GetHostingOverviewRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.GetHostingOverviewRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.GetHostingOverviewRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.GetHostingOverviewRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.eaconnect.GetHostingOverviewRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.GetHostingOverviewRequest} returns this
 */
proto.eaconnect.GetHostingOverviewRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.HostingOverview.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.HostingOverview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.HostingOverview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.HostingOverview.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
slotLimit: jspb.Message.getFieldWithDefault(msg, 2, 0),
slotsUsed: jspb.Message.getFieldWithDefault(msg, 3, 0),
runningCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
status: jspb.Message.getFieldWithDefault(msg, 5, ""),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.HostingOverview}
 */
proto.eaconnect.HostingOverview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.HostingOverview;
  return proto.eaconnect.HostingOverview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.HostingOverview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.HostingOverview}
 */
proto.eaconnect.HostingOverview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSlotLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSlotsUsed(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRunningCount(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.HostingOverview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.HostingOverview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.HostingOverview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.HostingOverview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlotLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSlotsUsed();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getRunningCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.eaconnect.HostingOverview.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.HostingOverview} returns this
 */
proto.eaconnect.HostingOverview.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 slot_limit = 2;
 * @return {number}
 */
proto.eaconnect.HostingOverview.prototype.getSlotLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.HostingOverview} returns this
 */
proto.eaconnect.HostingOverview.prototype.setSlotLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 slots_used = 3;
 * @return {number}
 */
proto.eaconnect.HostingOverview.prototype.getSlotsUsed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.HostingOverview} returns this
 */
proto.eaconnect.HostingOverview.prototype.setSlotsUsed = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 running_count = 4;
 * @return {number}
 */
proto.eaconnect.HostingOverview.prototype.getRunningCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.HostingOverview} returns this
 */
proto.eaconnect.HostingOverview.prototype.setRunningCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.eaconnect.HostingOverview.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.HostingOverview} returns this
 */
proto.eaconnect.HostingOverview.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string subscription_id = 6;
 * @return {string}
 */
proto.eaconnect.HostingOverview.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.HostingOverview} returns this
 */
proto.eaconnect.HostingOverview.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.ListUploadsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.ListUploadsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.ListUploadsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ListUploadsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.ListUploadsRequest}
 */
proto.eaconnect.ListUploadsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.ListUploadsRequest;
  return proto.eaconnect.ListUploadsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.ListUploadsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.ListUploadsRequest}
 */
proto.eaconnect.ListUploadsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.ListUploadsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.ListUploadsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.ListUploadsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ListUploadsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.eaconnect.ListUploadsRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.ListUploadsRequest} returns this
 */
proto.eaconnect.ListUploadsRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.UploadEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.UploadEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.UploadEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.UploadEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
sha256: jspb.Message.getFieldWithDefault(msg, 1, ""),
eaArtifactId: jspb.Message.getFieldWithDefault(msg, 2, ""),
fileName: jspb.Message.getFieldWithDefault(msg, 3, ""),
platform: jspb.Message.getFieldWithDefault(msg, 4, ""),
status: jspb.Message.getFieldWithDefault(msg, 5, ""),
error: jspb.Message.getFieldWithDefault(msg, 6, ""),
inputCount: jspb.Message.getFieldWithDefault(msg, 7, 0),
schemaJson: jspb.Message.getFieldWithDefault(msg, 8, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.UploadEntry}
 */
proto.eaconnect.UploadEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.UploadEntry;
  return proto.eaconnect.UploadEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.UploadEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.UploadEntry}
 */
proto.eaconnect.UploadEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSha256(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEaArtifactId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setInputCount(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSchemaJson(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.UploadEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.UploadEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.UploadEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.UploadEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSha256();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEaArtifactId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getInputCount();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getSchemaJson();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string sha256 = 1;
 * @return {string}
 */
proto.eaconnect.UploadEntry.prototype.getSha256 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UploadEntry} returns this
 */
proto.eaconnect.UploadEntry.prototype.setSha256 = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ea_artifact_id = 2;
 * @return {string}
 */
proto.eaconnect.UploadEntry.prototype.getEaArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UploadEntry} returns this
 */
proto.eaconnect.UploadEntry.prototype.setEaArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string file_name = 3;
 * @return {string}
 */
proto.eaconnect.UploadEntry.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UploadEntry} returns this
 */
proto.eaconnect.UploadEntry.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string platform = 4;
 * @return {string}
 */
proto.eaconnect.UploadEntry.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UploadEntry} returns this
 */
proto.eaconnect.UploadEntry.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.eaconnect.UploadEntry.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UploadEntry} returns this
 */
proto.eaconnect.UploadEntry.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string error = 6;
 * @return {string}
 */
proto.eaconnect.UploadEntry.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UploadEntry} returns this
 */
proto.eaconnect.UploadEntry.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 input_count = 7;
 * @return {number}
 */
proto.eaconnect.UploadEntry.prototype.getInputCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.UploadEntry} returns this
 */
proto.eaconnect.UploadEntry.prototype.setInputCount = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string schema_json = 8;
 * @return {string}
 */
proto.eaconnect.UploadEntry.prototype.getSchemaJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.UploadEntry} returns this
 */
proto.eaconnect.UploadEntry.prototype.setSchemaJson = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.UploadEntry.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.UploadEntry} returns this
*/
proto.eaconnect.UploadEntry.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.UploadEntry} returns this
 */
proto.eaconnect.UploadEntry.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.UploadEntry.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.eaconnect.ListUploadsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.ListUploadsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.ListUploadsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.ListUploadsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ListUploadsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
uploadsList: jspb.Message.toObjectList(msg.getUploadsList(),
    proto.eaconnect.UploadEntry.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.ListUploadsResponse}
 */
proto.eaconnect.ListUploadsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.ListUploadsResponse;
  return proto.eaconnect.ListUploadsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.ListUploadsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.ListUploadsResponse}
 */
proto.eaconnect.ListUploadsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.eaconnect.UploadEntry;
      reader.readMessage(value,proto.eaconnect.UploadEntry.deserializeBinaryFromReader);
      msg.addUploads(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.ListUploadsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.ListUploadsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.ListUploadsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.ListUploadsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUploadsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.eaconnect.UploadEntry.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UploadEntry uploads = 1;
 * @return {!Array<!proto.eaconnect.UploadEntry>}
 */
proto.eaconnect.ListUploadsResponse.prototype.getUploadsList = function() {
  return /** @type{!Array<!proto.eaconnect.UploadEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.eaconnect.UploadEntry, 1));
};


/**
 * @param {!Array<!proto.eaconnect.UploadEntry>} value
 * @return {!proto.eaconnect.ListUploadsResponse} returns this
*/
proto.eaconnect.ListUploadsResponse.prototype.setUploadsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.eaconnect.UploadEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.eaconnect.UploadEntry}
 */
proto.eaconnect.ListUploadsResponse.prototype.addUploads = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.eaconnect.UploadEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.eaconnect.ListUploadsResponse} returns this
 */
proto.eaconnect.ListUploadsResponse.prototype.clearUploadsList = function() {
  return this.setUploadsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.DismissUploadRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.DismissUploadRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.DismissUploadRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.DismissUploadRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
sha256: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.DismissUploadRequest}
 */
proto.eaconnect.DismissUploadRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.DismissUploadRequest;
  return proto.eaconnect.DismissUploadRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.DismissUploadRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.DismissUploadRequest}
 */
proto.eaconnect.DismissUploadRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSha256(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.DismissUploadRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.DismissUploadRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.DismissUploadRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.DismissUploadRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSha256();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.eaconnect.DismissUploadRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.DismissUploadRequest} returns this
 */
proto.eaconnect.DismissUploadRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string sha256 = 2;
 * @return {string}
 */
proto.eaconnect.DismissUploadRequest.prototype.getSha256 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.DismissUploadRequest} returns this
 */
proto.eaconnect.DismissUploadRequest.prototype.setSha256 = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.DismissUploadResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.DismissUploadResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.DismissUploadResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.DismissUploadResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.DismissUploadResponse}
 */
proto.eaconnect.DismissUploadResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.DismissUploadResponse;
  return proto.eaconnect.DismissUploadResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.DismissUploadResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.DismissUploadResponse}
 */
proto.eaconnect.DismissUploadResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.DismissUploadResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.DismissUploadResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.DismissUploadResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.DismissUploadResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.eaconnect.StreamLifecycleEventsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.StreamLifecycleEventsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.StreamLifecycleEventsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.StreamLifecycleEventsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.StreamLifecycleEventsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
instanceIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.StreamLifecycleEventsRequest}
 */
proto.eaconnect.StreamLifecycleEventsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.StreamLifecycleEventsRequest;
  return proto.eaconnect.StreamLifecycleEventsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.StreamLifecycleEventsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.StreamLifecycleEventsRequest}
 */
proto.eaconnect.StreamLifecycleEventsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addInstanceIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.StreamLifecycleEventsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.StreamLifecycleEventsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.StreamLifecycleEventsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.StreamLifecycleEventsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstanceIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string instance_ids = 1;
 * @return {!Array<string>}
 */
proto.eaconnect.StreamLifecycleEventsRequest.prototype.getInstanceIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.eaconnect.StreamLifecycleEventsRequest} returns this
 */
proto.eaconnect.StreamLifecycleEventsRequest.prototype.setInstanceIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.eaconnect.StreamLifecycleEventsRequest} returns this
 */
proto.eaconnect.StreamLifecycleEventsRequest.prototype.addInstanceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.eaconnect.StreamLifecycleEventsRequest} returns this
 */
proto.eaconnect.StreamLifecycleEventsRequest.prototype.clearInstanceIdsList = function() {
  return this.setInstanceIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.LifecycleUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.LifecycleUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.LifecycleUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.LifecycleUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
instanceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
ts: (f = msg.getTs()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
status: jspb.Message.getFieldWithDefault(msg, 3, ""),
eventType: jspb.Message.getFieldWithDefault(msg, 4, ""),
failureCode: jspb.Message.getFieldWithDefault(msg, 5, ""),
workerUid: jspb.Message.getFieldWithDefault(msg, 6, ""),
workerIncarnationId: jspb.Message.getFieldWithDefault(msg, 7, ""),
assignmentEpoch: jspb.Message.getFieldWithDefault(msg, 8, 0),
runGeneration: jspb.Message.getFieldWithDefault(msg, 9, 0),
eventSequence: jspb.Message.getFieldWithDefault(msg, 10, 0),
settingsVersion: jspb.Message.getFieldWithDefault(msg, 11, 0),
phase: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.LifecycleUpdate}
 */
proto.eaconnect.LifecycleUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.LifecycleUpdate;
  return proto.eaconnect.LifecycleUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.LifecycleUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.LifecycleUpdate}
 */
proto.eaconnect.LifecycleUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstanceId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTs(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFailureCode(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkerUid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkerIncarnationId(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAssignmentEpoch(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRunGeneration(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setEventSequence(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSettingsVersion(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhase(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.LifecycleUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.LifecycleUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.LifecycleUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.LifecycleUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstanceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTs();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEventType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFailureCode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getWorkerUid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getWorkerIncarnationId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAssignmentEpoch();
  if (f !== 0) {
    writer.writeUint64(
      8,
      f
    );
  }
  f = message.getRunGeneration();
  if (f !== 0) {
    writer.writeUint64(
      9,
      f
    );
  }
  f = message.getEventSequence();
  if (f !== 0) {
    writer.writeUint64(
      10,
      f
    );
  }
  f = message.getSettingsVersion();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getPhase();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional string instance_id = 1;
 * @return {string}
 */
proto.eaconnect.LifecycleUpdate.prototype.getInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.LifecycleUpdate} returns this
 */
proto.eaconnect.LifecycleUpdate.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp ts = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.LifecycleUpdate.prototype.getTs = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.LifecycleUpdate} returns this
*/
proto.eaconnect.LifecycleUpdate.prototype.setTs = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.LifecycleUpdate} returns this
 */
proto.eaconnect.LifecycleUpdate.prototype.clearTs = function() {
  return this.setTs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.LifecycleUpdate.prototype.hasTs = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string status = 3;
 * @return {string}
 */
proto.eaconnect.LifecycleUpdate.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.LifecycleUpdate} returns this
 */
proto.eaconnect.LifecycleUpdate.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string event_type = 4;
 * @return {string}
 */
proto.eaconnect.LifecycleUpdate.prototype.getEventType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.LifecycleUpdate} returns this
 */
proto.eaconnect.LifecycleUpdate.prototype.setEventType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string failure_code = 5;
 * @return {string}
 */
proto.eaconnect.LifecycleUpdate.prototype.getFailureCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.LifecycleUpdate} returns this
 */
proto.eaconnect.LifecycleUpdate.prototype.setFailureCode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string worker_uid = 6;
 * @return {string}
 */
proto.eaconnect.LifecycleUpdate.prototype.getWorkerUid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.LifecycleUpdate} returns this
 */
proto.eaconnect.LifecycleUpdate.prototype.setWorkerUid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string worker_incarnation_id = 7;
 * @return {string}
 */
proto.eaconnect.LifecycleUpdate.prototype.getWorkerIncarnationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.LifecycleUpdate} returns this
 */
proto.eaconnect.LifecycleUpdate.prototype.setWorkerIncarnationId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional uint64 assignment_epoch = 8;
 * @return {number}
 */
proto.eaconnect.LifecycleUpdate.prototype.getAssignmentEpoch = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.LifecycleUpdate} returns this
 */
proto.eaconnect.LifecycleUpdate.prototype.setAssignmentEpoch = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional uint64 run_generation = 9;
 * @return {number}
 */
proto.eaconnect.LifecycleUpdate.prototype.getRunGeneration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.LifecycleUpdate} returns this
 */
proto.eaconnect.LifecycleUpdate.prototype.setRunGeneration = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional uint64 event_sequence = 10;
 * @return {number}
 */
proto.eaconnect.LifecycleUpdate.prototype.getEventSequence = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.LifecycleUpdate} returns this
 */
proto.eaconnect.LifecycleUpdate.prototype.setEventSequence = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 settings_version = 11;
 * @return {number}
 */
proto.eaconnect.LifecycleUpdate.prototype.getSettingsVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.LifecycleUpdate} returns this
 */
proto.eaconnect.LifecycleUpdate.prototype.setSettingsVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string phase = 12;
 * @return {string}
 */
proto.eaconnect.LifecycleUpdate.prototype.getPhase = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.LifecycleUpdate} returns this
 */
proto.eaconnect.LifecycleUpdate.prototype.setPhase = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.StreamInstanceLogsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.StreamInstanceLogsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.StreamInstanceLogsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.StreamInstanceLogsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
instanceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
follow: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
view: jspb.Message.getFieldWithDefault(msg, 3, 0),
tailLines: jspb.Message.getFieldWithDefault(msg, 4, 0),
afterCursor: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.StreamInstanceLogsRequest}
 */
proto.eaconnect.StreamInstanceLogsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.StreamInstanceLogsRequest;
  return proto.eaconnect.StreamInstanceLogsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.StreamInstanceLogsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.StreamInstanceLogsRequest}
 */
proto.eaconnect.StreamInstanceLogsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstanceId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFollow(value);
      break;
    case 3:
      var value = /** @type {!proto.eaconnect.LogStreamView} */ (reader.readEnum());
      msg.setView(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTailLines(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAfterCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.StreamInstanceLogsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.StreamInstanceLogsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.StreamInstanceLogsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.StreamInstanceLogsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstanceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFollow();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getView();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getTailLines();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getAfterCursor();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string instance_id = 1;
 * @return {string}
 */
proto.eaconnect.StreamInstanceLogsRequest.prototype.getInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.StreamInstanceLogsRequest} returns this
 */
proto.eaconnect.StreamInstanceLogsRequest.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool follow = 2;
 * @return {boolean}
 */
proto.eaconnect.StreamInstanceLogsRequest.prototype.getFollow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.StreamInstanceLogsRequest} returns this
 */
proto.eaconnect.StreamInstanceLogsRequest.prototype.setFollow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional LogStreamView view = 3;
 * @return {!proto.eaconnect.LogStreamView}
 */
proto.eaconnect.StreamInstanceLogsRequest.prototype.getView = function() {
  return /** @type {!proto.eaconnect.LogStreamView} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.eaconnect.LogStreamView} value
 * @return {!proto.eaconnect.StreamInstanceLogsRequest} returns this
 */
proto.eaconnect.StreamInstanceLogsRequest.prototype.setView = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional uint32 tail_lines = 4;
 * @return {number}
 */
proto.eaconnect.StreamInstanceLogsRequest.prototype.getTailLines = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.StreamInstanceLogsRequest} returns this
 */
proto.eaconnect.StreamInstanceLogsRequest.prototype.setTailLines = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string after_cursor = 5;
 * @return {string}
 */
proto.eaconnect.StreamInstanceLogsRequest.prototype.getAfterCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.StreamInstanceLogsRequest} returns this
 */
proto.eaconnect.StreamInstanceLogsRequest.prototype.setAfterCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.LogStreamIdentity.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.LogStreamIdentity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.LogStreamIdentity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.LogStreamIdentity.toObject = function(includeInstance, msg) {
  var f, obj = {
instanceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
workerUid: jspb.Message.getFieldWithDefault(msg, 2, ""),
workerIncarnationId: jspb.Message.getFieldWithDefault(msg, 3, ""),
assignmentEpoch: jspb.Message.getFieldWithDefault(msg, 4, 0),
runGeneration: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.LogStreamIdentity}
 */
proto.eaconnect.LogStreamIdentity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.LogStreamIdentity;
  return proto.eaconnect.LogStreamIdentity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.LogStreamIdentity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.LogStreamIdentity}
 */
proto.eaconnect.LogStreamIdentity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstanceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkerUid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkerIncarnationId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAssignmentEpoch(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRunGeneration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.LogStreamIdentity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.LogStreamIdentity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.LogStreamIdentity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.LogStreamIdentity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstanceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWorkerUid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWorkerIncarnationId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAssignmentEpoch();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getRunGeneration();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
};


/**
 * optional string instance_id = 1;
 * @return {string}
 */
proto.eaconnect.LogStreamIdentity.prototype.getInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.LogStreamIdentity} returns this
 */
proto.eaconnect.LogStreamIdentity.prototype.setInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string worker_uid = 2;
 * @return {string}
 */
proto.eaconnect.LogStreamIdentity.prototype.getWorkerUid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.LogStreamIdentity} returns this
 */
proto.eaconnect.LogStreamIdentity.prototype.setWorkerUid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string worker_incarnation_id = 3;
 * @return {string}
 */
proto.eaconnect.LogStreamIdentity.prototype.getWorkerIncarnationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.LogStreamIdentity} returns this
 */
proto.eaconnect.LogStreamIdentity.prototype.setWorkerIncarnationId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint64 assignment_epoch = 4;
 * @return {number}
 */
proto.eaconnect.LogStreamIdentity.prototype.getAssignmentEpoch = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.LogStreamIdentity} returns this
 */
proto.eaconnect.LogStreamIdentity.prototype.setAssignmentEpoch = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint64 run_generation = 5;
 * @return {number}
 */
proto.eaconnect.LogStreamIdentity.prototype.getRunGeneration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.eaconnect.LogStreamIdentity} returns this
 */
proto.eaconnect.LogStreamIdentity.prototype.setRunGeneration = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.StreamLogLine.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.StreamLogLine.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.StreamLogLine} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.StreamLogLine.toObject = function(includeInstance, msg) {
  var f, obj = {
ts: (f = msg.getTs()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
text: jspb.Message.getFieldWithDefault(msg, 2, ""),
view: jspb.Message.getFieldWithDefault(msg, 3, 0),
physicalSource: jspb.Message.getFieldWithDefault(msg, 4, ""),
component: jspb.Message.getFieldWithDefault(msg, 5, ""),
cursor: jspb.Message.getFieldWithDefault(msg, 6, ""),
phase: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.StreamLogLine}
 */
proto.eaconnect.StreamLogLine.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.StreamLogLine;
  return proto.eaconnect.StreamLogLine.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.StreamLogLine} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.StreamLogLine}
 */
proto.eaconnect.StreamLogLine.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTs(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 3:
      var value = /** @type {!proto.eaconnect.LogStreamView} */ (reader.readEnum());
      msg.setView(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhysicalSource(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setComponent(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursor(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhase(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.StreamLogLine.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.StreamLogLine.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.StreamLogLine} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.StreamLogLine.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTs();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getView();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPhysicalSource();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getComponent();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCursor();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPhase();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp ts = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.eaconnect.StreamLogLine.prototype.getTs = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.eaconnect.StreamLogLine} returns this
*/
proto.eaconnect.StreamLogLine.prototype.setTs = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.StreamLogLine} returns this
 */
proto.eaconnect.StreamLogLine.prototype.clearTs = function() {
  return this.setTs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.StreamLogLine.prototype.hasTs = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string text = 2;
 * @return {string}
 */
proto.eaconnect.StreamLogLine.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.StreamLogLine} returns this
 */
proto.eaconnect.StreamLogLine.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional LogStreamView view = 3;
 * @return {!proto.eaconnect.LogStreamView}
 */
proto.eaconnect.StreamLogLine.prototype.getView = function() {
  return /** @type {!proto.eaconnect.LogStreamView} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.eaconnect.LogStreamView} value
 * @return {!proto.eaconnect.StreamLogLine} returns this
 */
proto.eaconnect.StreamLogLine.prototype.setView = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string physical_source = 4;
 * @return {string}
 */
proto.eaconnect.StreamLogLine.prototype.getPhysicalSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.StreamLogLine} returns this
 */
proto.eaconnect.StreamLogLine.prototype.setPhysicalSource = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string component = 5;
 * @return {string}
 */
proto.eaconnect.StreamLogLine.prototype.getComponent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.StreamLogLine} returns this
 */
proto.eaconnect.StreamLogLine.prototype.setComponent = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string cursor = 6;
 * @return {string}
 */
proto.eaconnect.StreamLogLine.prototype.getCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.StreamLogLine} returns this
 */
proto.eaconnect.StreamLogLine.prototype.setCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string phase = 7;
 * @return {string}
 */
proto.eaconnect.StreamLogLine.prototype.getPhase = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.StreamLogLine} returns this
 */
proto.eaconnect.StreamLogLine.prototype.setPhase = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.LogStreamClose.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.LogStreamClose.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.LogStreamClose} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.LogStreamClose.toObject = function(includeInstance, msg) {
  var f, obj = {
collectionCompleted: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
responseTruncated: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
historicalCoverage: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.LogStreamClose}
 */
proto.eaconnect.LogStreamClose.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.LogStreamClose;
  return proto.eaconnect.LogStreamClose.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.LogStreamClose} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.LogStreamClose}
 */
proto.eaconnect.LogStreamClose.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCollectionCompleted(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setResponseTruncated(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHistoricalCoverage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.LogStreamClose.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.LogStreamClose.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.LogStreamClose} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.LogStreamClose.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCollectionCompleted();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getResponseTruncated();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getHistoricalCoverage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional bool collection_completed = 1;
 * @return {boolean}
 */
proto.eaconnect.LogStreamClose.prototype.getCollectionCompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.LogStreamClose} returns this
 */
proto.eaconnect.LogStreamClose.prototype.setCollectionCompleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool response_truncated = 2;
 * @return {boolean}
 */
proto.eaconnect.LogStreamClose.prototype.getResponseTruncated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.LogStreamClose} returns this
 */
proto.eaconnect.LogStreamClose.prototype.setResponseTruncated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string historical_coverage = 3;
 * @return {string}
 */
proto.eaconnect.LogStreamClose.prototype.getHistoricalCoverage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.eaconnect.LogStreamClose} returns this
 */
proto.eaconnect.LogStreamClose.prototype.setHistoricalCoverage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.eaconnect.LogStreamFrame.oneofGroups_ = [[2,3,4]];

/**
 * @enum {number}
 */
proto.eaconnect.LogStreamFrame.RecordCase = {
  RECORD_NOT_SET: 0,
  HEADER: 2,
  LINE: 3,
  CLOSE: 4
};

/**
 * @return {proto.eaconnect.LogStreamFrame.RecordCase}
 */
proto.eaconnect.LogStreamFrame.prototype.getRecordCase = function() {
  return /** @type {proto.eaconnect.LogStreamFrame.RecordCase} */(jspb.Message.computeOneofCase(this, proto.eaconnect.LogStreamFrame.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.eaconnect.LogStreamFrame.prototype.toObject = function(opt_includeInstance) {
  return proto.eaconnect.LogStreamFrame.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.eaconnect.LogStreamFrame} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.LogStreamFrame.toObject = function(includeInstance, msg) {
  var f, obj = {
identity: (f = msg.getIdentity()) && proto.eaconnect.LogStreamIdentity.toObject(includeInstance, f),
header: (f = jspb.Message.getBooleanField(msg, 2)) == null ? undefined : f,
line: (f = msg.getLine()) && proto.eaconnect.StreamLogLine.toObject(includeInstance, f),
close: (f = msg.getClose()) && proto.eaconnect.LogStreamClose.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.eaconnect.LogStreamFrame}
 */
proto.eaconnect.LogStreamFrame.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.eaconnect.LogStreamFrame;
  return proto.eaconnect.LogStreamFrame.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.eaconnect.LogStreamFrame} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.eaconnect.LogStreamFrame}
 */
proto.eaconnect.LogStreamFrame.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.eaconnect.LogStreamIdentity;
      reader.readMessage(value,proto.eaconnect.LogStreamIdentity.deserializeBinaryFromReader);
      msg.setIdentity(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHeader(value);
      break;
    case 3:
      var value = new proto.eaconnect.StreamLogLine;
      reader.readMessage(value,proto.eaconnect.StreamLogLine.deserializeBinaryFromReader);
      msg.setLine(value);
      break;
    case 4:
      var value = new proto.eaconnect.LogStreamClose;
      reader.readMessage(value,proto.eaconnect.LogStreamClose.deserializeBinaryFromReader);
      msg.setClose(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.eaconnect.LogStreamFrame.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.eaconnect.LogStreamFrame.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.eaconnect.LogStreamFrame} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.eaconnect.LogStreamFrame.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentity();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.eaconnect.LogStreamIdentity.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getLine();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.eaconnect.StreamLogLine.serializeBinaryToWriter
    );
  }
  f = message.getClose();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.eaconnect.LogStreamClose.serializeBinaryToWriter
    );
  }
};


/**
 * optional LogStreamIdentity identity = 1;
 * @return {?proto.eaconnect.LogStreamIdentity}
 */
proto.eaconnect.LogStreamFrame.prototype.getIdentity = function() {
  return /** @type{?proto.eaconnect.LogStreamIdentity} */ (
    jspb.Message.getWrapperField(this, proto.eaconnect.LogStreamIdentity, 1));
};


/**
 * @param {?proto.eaconnect.LogStreamIdentity|undefined} value
 * @return {!proto.eaconnect.LogStreamFrame} returns this
*/
proto.eaconnect.LogStreamFrame.prototype.setIdentity = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.LogStreamFrame} returns this
 */
proto.eaconnect.LogStreamFrame.prototype.clearIdentity = function() {
  return this.setIdentity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.LogStreamFrame.prototype.hasIdentity = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool header = 2;
 * @return {boolean}
 */
proto.eaconnect.LogStreamFrame.prototype.getHeader = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.eaconnect.LogStreamFrame} returns this
 */
proto.eaconnect.LogStreamFrame.prototype.setHeader = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.eaconnect.LogStreamFrame.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.eaconnect.LogStreamFrame} returns this
 */
proto.eaconnect.LogStreamFrame.prototype.clearHeader = function() {
  return jspb.Message.setOneofField(this, 2, proto.eaconnect.LogStreamFrame.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.LogStreamFrame.prototype.hasHeader = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional StreamLogLine line = 3;
 * @return {?proto.eaconnect.StreamLogLine}
 */
proto.eaconnect.LogStreamFrame.prototype.getLine = function() {
  return /** @type{?proto.eaconnect.StreamLogLine} */ (
    jspb.Message.getWrapperField(this, proto.eaconnect.StreamLogLine, 3));
};


/**
 * @param {?proto.eaconnect.StreamLogLine|undefined} value
 * @return {!proto.eaconnect.LogStreamFrame} returns this
*/
proto.eaconnect.LogStreamFrame.prototype.setLine = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.eaconnect.LogStreamFrame.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.LogStreamFrame} returns this
 */
proto.eaconnect.LogStreamFrame.prototype.clearLine = function() {
  return this.setLine(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.LogStreamFrame.prototype.hasLine = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional LogStreamClose close = 4;
 * @return {?proto.eaconnect.LogStreamClose}
 */
proto.eaconnect.LogStreamFrame.prototype.getClose = function() {
  return /** @type{?proto.eaconnect.LogStreamClose} */ (
    jspb.Message.getWrapperField(this, proto.eaconnect.LogStreamClose, 4));
};


/**
 * @param {?proto.eaconnect.LogStreamClose|undefined} value
 * @return {!proto.eaconnect.LogStreamFrame} returns this
*/
proto.eaconnect.LogStreamFrame.prototype.setClose = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.eaconnect.LogStreamFrame.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.eaconnect.LogStreamFrame} returns this
 */
proto.eaconnect.LogStreamFrame.prototype.clearClose = function() {
  return this.setClose(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.eaconnect.LogStreamFrame.prototype.hasClose = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * @enum {number}
 */
proto.eaconnect.LogStreamView = {
  LOG_STREAM_VIEW_UNSPECIFIED: 0,
  LOG_STREAM_VIEW_OPERATIONAL: 1,
  LOG_STREAM_VIEW_JOURNAL: 2,
  LOG_STREAM_VIEW_EXPERTS: 3,
  LOG_STREAM_VIEW_ALL_PLATFORM: 4
};

goog.object.extend(exports, proto.eaconnect);
